
import ProfileIcon from '../assets/images/icon_menus/User Profile.svg';

export const customerTypeList = [
    { id: 'BUSINESS', label: 'Business' },
    { id: 'INDIVIDUAL', label: 'Individual' }
];

// export const classificationList = [
//     { id: 'MANUFACTURER', label: 'OEM' },
//     { id: 'DISTRIBUTOR', label: 'Distributor' },
//     { id: 'AGENT/DEALER', label: 'Agent/Dealer' },
//     { id: 'RETAILER', label: 'Retailer' },
//     { id: 'CONSUMER', label: 'Consumer' },
//     { id: 'OTHER', label: 'Other' }
// ];

export const classificationList = [
    { id: 'HOUSEHOLD/CONSUMER', label: 'Household / Consumer' },
    { id: 'WHOLESALE', label: 'Wholesale' },
    { id: 'SHOP/RETAILER', label: 'Shop/Retailer' },
    { id: 'AGENT/DEALER', label: 'Agent/Dealer' },
    { id: 'DISTRIBUTOR', label: 'Distributor' },
    { id: 'MANUFACTURER', label: 'Manufacturer' },
    { id: 'OTHER', label: 'Other' }
];

export const gstTypeList = [
    { id: 'CONSUMER', label: 'Consumer' },
    { id: 'UNREGISTERED BUSINESS', label: 'Unregistered business' },
    { id: 'REGULAR- REGISTERED BUSINESS', label: 'Reqular-Registered business' },
    { id: 'CASUAL TAXABLE PERSON (CTP)', label: 'Casual Taxable Person(CTP)' },
    { id: 'NON- RESIDENT TAXABLE PERSON (NRTP)', label: 'Non-Resident Taxable Person(NRTP)' },
    { id: 'SEZ - SPECIAL ECONOMIC ZONE', label: 'Special Economic Zone(SEZ)' },
    { id: 'COMPOSITE SCHEME', label: 'Composite Scheme' }
];

export const customerBusinessTypeList = [
    { id: 'HOUSEHOLD/CONSUMER', label: 'Household/Consumer' },
    { id: 'WHOLESALE', label: 'Wholesale' },
    { id: 'SHOP/RETAILER', label: 'Shop/Retailer' },
    { id: 'AGENT/DEALER', label: 'Agent/Dealer' },
    { id: 'DISTRIBUTOR', label: 'Distributor' },
    { id: 'MANUFACTURER', label: 'Manufacturer' },
    { id: 'OTHER', label: 'Other' }
];

export const salesPriceHead = [
    { 'key': 'priceId', 'name': 'Price ID' },
    { 'key': 'product', 'name': 'Product' },
    { 'key': 'fromDate', 'name': 'From Date' },
    { 'key': 'toDate', 'name': 'To Date' },
    { 'key': 'fromQty', 'name': 'From Qty.' },
    { 'key': 'toQty', 'name': 'To Qty.' },
    { 'key': 'discount', 'name': 'Discount %' },
    { 'key': 'discountAmount', 'name': 'Discount Amount' },
    { 'key': 'action', 'name': 'Actions', 'actionWidth': true }
];

export const allCustomerProductHead = [
    { 'key': 'productId', 'name': 'Product ID' },
    { 'key': 'product', 'name': 'Product' },
    { 'key': 'catalogueName', 'name': 'Catalogue Name' },
    { 'key': 'categoryName', 'name': 'Category Name' },
    { 'key': 'startDate', 'name': 'Start Date' },
    { 'key': 'quantity', 'name': 'Quantity' },
    { 'key': 'salesUnit', 'name': 'Sales Unit' },
    { 'key': 'frequency', 'name': 'Frequency' },
    { 'key': 'freqDetail', 'name': 'Freq.Detail' },
    { 'key': 'action', 'name': 'Actions', 'actionWidth': "55px" }
]

export const pointOfSalesHead = [
    { 'key': 'id', 'name': 'POS No.', 'sorting': true },
    { 'key': 'description', 'name': 'Description', 'sorting': true },
    { 'key': 'defaultCustomer', 'name': 'Default Customer' },
    { 'key': 'defaultUser', 'name': 'Default User' },
    { 'key': 'defaultMop', 'name': 'Default MOP' }, { 'key': 'location', 'name': 'Location' },
    { 'key': 'action', 'name': 'Actions', 'actionWidth': "115px" }

]

export const inventoryDisableMenus = ['Adjust Stock', 'Stock Count', 'Stock Transfer', 'Stock Transaction', 'Stock on Hand', 'Inventory Transaction', 'Batch Numbers'];

export const productMenus = {
    menu: "Product",
    link: '/product',
    icon: true,
    sub: [
        {
            menu: 'Product',
            link: '/product',
            icon: true,
            sub: [
                {
                    menu: 'My Catalogue',
                    link: '/catalogue',
                    icon: false,
                },
                {
                    menu: 'My Products',
                    link: '/product/product/my-products',
                    icon: false,
                },
                {
                    menu: 'Maintain Price',
                    link: '/product/setup/maintain-price',
                    icon: false,
                },
                {
                    menu: 'Minimum Stock Quantity',
                    link: '/minimum-stock-quantity',
                    icon: false,
                },
                {
                    menu: 'Supplier Products',
                    link: '/supplier-products',
                    icon: false,
                },
                {
                    menu: 'Adjust Stock',
                    link: '/product/inventory/adjust-stock',
                    icon: false,
                },
                {
                    menu: 'Stock Count',
                    link: '/product/inventory/stock-count',
                    icon: false,
                },
                {
                    menu: 'Stock Transfer',
                    link: '/product/inventory/stock-transfer',
                    icon: false,
                },
            ]
        },
        {
            menu: 'Inventory',
            link: '/inventory',
            icon: true,
            sub: [
                {
                    menu: 'Stock Transaction',
                    link: '/product/inventory/stock-transaction',
                    icon: false,
                },
                {
                    menu: 'Stock on Hand',
                    link: '/product/inventory/stock-on-hand',
                    icon: false,
                },
                {
                    menu: 'Inventory Transaction',
                    link: '/product/inventory/inventory-transaction',
                    icon: false,
                },

                {
                    menu: 'Opening Balances',
                    link: '/opening-balance',
                    icon: false,
                },
                {
                    menu: 'Batch Numbers',
                    link: '/product/inventory/batch-numbers',
                    icon: false,
                },
            ]
        },
        {
            menu: 'Report & Enquiry',
            link: '/report-enquiry',
            icon: true,
            sub: [
                {
                    menu: 'Stock Report By Location',
                    link: '/adjust-stock',
                    icon: false,
                },
                {
                    menu: 'Batch Level Stock Info',
                    link: '/stock-count',
                    icon: false,
                },
                {
                    menu: 'Product-wise Analysis',
                    link: '#',
                    onClick: true,
                    icon: false,
                },
                {
                    menu: 'Product Group wise Analysis',
                    link: '#',
                    onClick: true,
                    icon: false,
                },
                {
                    menu: 'Top Products Supply',
                    link: '#',
                    onClick: true,
                    icon: false,
                },
                {
                    menu: 'Expired Products',
                    link: '/batch-number',
                    icon: false,
                },
                {
                    menu: 'Stock Value Report',
                    link: '#',
                    onClick: true,
                    icon: false,
                },
                {
                    menu: 'Transfer Value Report',
                    link: '#',
                    onClick: true,
                    icon: false,
                },
                {
                    menu: 'Net Order Report',
                    link: '#',
                    onClick: true,
                    icon: false,
                },
            ]
        },
        {
            menu: 'Setup',
            link: '/setup',
            icon: true,
            sub: [
                {
                    menu: 'Location',
                    link: '/product/setup/location',
                    icon: false,
                },
                {
                    menu: 'Product Group',
                    link: "/product/setup/product-group",
                    icon: false,
                },
                {
                    menu: 'Product GST Code',
                    link: '/stock-count',
                    icon: false,
                },
                {
                    menu: 'Product HSN Code',
                    link: '/opening-balance',
                    icon: false,
                },
                {
                    menu: 'Product Unit Conversions',
                    link: "/product/setup/units/product-unit-conversions",
                    icon: false,
                }
            ]
        },
    ]
}

export const salesMenusNew = [
    {
        key: '1',
        type: 'group',
        label: 'Group title',
        children: [
            {
                key: '1-1',
                label: '1st menu item',
            },
            {
                key: '1-2',
                label: '2nd menu item',
            },
        ],
    },
    {
        key: '2',
        label: 'sub menu',
        children: [
            {
                key: '2-1',
                label: '3rd menu item',
            },
            {
                key: '2-2',
                label: '4th menu item',
            },
        ],
    },
    {
        key: '3',
        label: 'disabled sub menu',
        disabled: true,
        children: [
            {
                key: '3-1',
                label: '5d menu item',
            },
            {
                key: '3-2',
                label: '6th menu item',
            },
        ],
    },
];

export const salesMenus = {
    menu: "Sales",
    link: '/sales',
    icon: true,
    sub: [
        {
            menu: 'Sales Management',
            link: '/sales-management',
            icon: true,
            sub: [
                {
                    menu: 'All Customers',
                    link: '/sales/sales-management/all-customers',
                    icon: false,
                },
                {
                    menu: 'Sales Order',
                    link: '/sales/sales-management/sales-order',
                    icon: false,
                },
                {
                    menu: 'Sales Quote',
                    link: '/sales/sales-management/sales-quote',
                    icon: false,
                },
                {
                    menu: 'Sales Bill',
                    link: '/sales/sales-management/self-bill',
                    icon: false,
                },
                {
                    menu: 'Store Sales',
                    link: '/sales/sales-management/store-sales',
                    icon: false,
                },
                {
                    menu: 'Customer Payment',
                    link: '/sales/sales-management/customer-payment',
                    icon: false,
                },
            ]
        },
        {
            menu: 'Transactions',
            link: '/transactions',
            icon: true,
            sub: [
                {
                    menu: 'Customer Transactions',
                    link: '/sales/transactions/customer-transactions',
                    icon: false,
                },
                {
                    menu: 'Customer Invoice History',
                    link: '/sales/transactions/invoice-history',
                    icon: false,
                },
                {
                    menu: 'Delivery Note History',
                    link: '/sales/transactions/delivery-note',
                    icon: false,
                },
            ]
        },
        {
            menu: 'Report & Enquiry',
            link: '/report-enquiry',
            icon: true,
            sub: [
                {
                    menu: 'Inactive Customers',
                    link: '#',
                    onClick: true,
                    icon: false,
                },
                {
                    menu: 'Customer Aged Dues',
                    link: '#',
                    onClick: true,
                    icon: false,
                },
                {
                    menu: 'Customer Invoice Report',
                    link: '#',
                    onClick: true,
                    icon: false,
                },
                {
                    menu: 'Sales By Location',
                    link: '#',
                    onClick: true,
                    icon: false,
                },
                {
                    menu: 'Sales & Payment- Statement',
                    link: '#',
                    onClick: true,
                    icon: false,
                },
                {
                    menu: 'Staff sales and collection',
                    link: '#',
                    onClick: true,
                    icon: false,
                },
                {
                    menu: 'Sales Price Deviation',
                    link: '#',
                    onClick: true,
                    icon: false,
                },
            ]
        },
        {
            menu: 'Setup',
            link: '/setup',
            icon: true,
            sub: [
                {
                    menu: 'Customer Group',
                    link: '/sales/setup/customer-group',
                    icon: false,
                },
                {
                    menu: 'Customer Product Scheduling',
                    link: '/sales/setup/customer-product-scheduling',
                    icon: false,
                },
                {
                    menu: 'Customer Products',
                    link: '/sales/setup/customer-products',
                    icon: false,
                },
                {
                    menu: 'Customer Sales Price',
                    link: '/sales/setup/sales-price',
                    icon: false,
                },
                {
                    menu: 'Customer Sales Discount',
                    link: '/sales/setup/sales-discount',
                    icon: false,
                },
                {
                    menu: 'Point of Sale (POS)',
                    link: '/sales/setup/point-of-sales',
                    icon: false,
                },
                {
                    menu: 'GST Recalculation',
                    link: '/sales/setup/gst-recalculation',
                    icon: false,
                },
            ]
        },
    ]
}

export const purchaseMenus = {
    menu: "Purchase",
    link: '/purchase',
    icon: true,
    sub: [
        {
            menu: 'Purchase Management',
            link: '/purchase-management',
            icon: true,
            sub: [
                {
                    menu: 'All Suppliers',
                    link: '/purchase/purchase-management/all-suppliers',
                    icon: false,
                },
                {
                    menu: 'Purchase Order',
                    link: '/purchase/purchase-management/purchase-order',
                    icon: false,
                },
                {
                    menu: 'Planned Purchase Order',
                    link: '/purchase',
                    icon: false,
                },
                {
                    menu: 'Supply Quote',
                    link: '/purchase/purchase-management/supply-quote',
                    icon: false,
                },
                {
                    menu: 'Supply Self Bill',
                    link: '/purchase/purchase-management/self-bill',
                    icon: false,
                },
                {
                    menu: 'Supplier Payment',
                    link: '/purchase/purchase-management/supplier-payment',
                    icon: false,
                },
            ]
        },
        {
            menu: 'Transactions',
            link: '/transactions',
            icon: true,
            sub: [
                {
                    menu: 'Supplier Transactions',
                    link: '/purchase/transactions/supplier-transactions',
                    icon: false,
                },
                {
                    menu: 'Supplier Invoice History',
                    link: '/purchase/transactions/invoice-history',
                    icon: false,
                },
                {
                    menu: 'Goods Receipt Note',
                    link: '/purchase/transactions/goods-receipt-note',
                    icon: false,
                },
            ]
        },
        {
            menu: 'Report & Enquiry',
            link: '/report-enquiry',
            icon: true,
            sub: [
                {
                    menu: 'Supplier Spend Report',
                    link: '/all-suppliers',
                    icon: false,
                },
                {
                    menu: 'Open & Planned Supply Orders',
                    link: '/all-purchase-order',
                    icon: false,
                },
                {
                    menu: 'Deliveries Awaiting By Date',
                    link: '/planned-purchase-order',
                    icon: false,
                },
                {
                    menu: 'Top 10 Suppliers',
                    link: '#',
                    onClick: true,
                    icon: false,
                },
                {
                    menu: 'Resale Value Report',
                    link: '#',
                    onClick: true,
                    icon: false,
                },
            ]
        },
        {
            menu: 'Setup',
            link: '/setup',
            icon: true,
            sub: [
                {
                    menu: 'Supplier Group',
                    link: '/purchase/setup/supplier-group',
                    icon: false,
                },
                {
                    menu: 'Minimum Stock Quantity',
                    link: '/all-purchase-order',
                    icon: false,
                },
                {
                    menu: 'Supplier Purchase Price',
                    link: '/purchase/setup/purchase-price',
                    icon: false,
                },
                {
                    menu: 'Supplier Products',
                    link: '/supplier-payment',
                    icon: false,
                },
            ]
        },
    ]
}

export const deliveryMenus = {
    menu: "Delivery",
    link: '/delivery',
    icon: true,
    sub: [
        {
            menu: 'Delivery Management',
            link: '/delivery-management',
            icon: true,
            sub: [
                {
                    menu: 'All Sales Order',
                    link: '/all-sales-order',
                    icon: false,
                },
                {
                    menu: 'Daily Load',
                    link: '/daily-load',
                    icon: false,
                },
                {
                    menu: 'Start Delivery',
                    link: '/start-delivery',
                    icon: false,
                },
            ]
        },
        {
            menu: 'Transactions',
            link: '/transactions',
            icon: true,
            sub: [
                {
                    menu: 'Route Settlement',
                    link: '/all-sales-order',
                    icon: false,
                },
                {
                    menu: 'Load History',
                    link: '/daily-load',
                    icon: false,
                },
            ]
        },
        {
            menu: 'Report & Enquiry',
            link: '/report-enquiry',
            icon: true,
            sub: [
                {
                    menu: 'Route Metrics',
                    link: '/all-sales-order',
                    icon: false,
                },
                {
                    menu: 'Delivery Leader Board',
                    link: '/daily-load',
                    icon: false,
                },
            ]
        },
        {
            menu: 'Setup',
            link: '/setup',
            icon: true,
            sub: [
                {
                    menu: 'Vehicle',
                    link: '/all-sales-order',
                    icon: false,
                },
                {
                    menu: 'Route',
                    link: '/daily-load',
                    icon: false,
                },
            ]
        },
    ]
}

export const adminMenus = {
    menu: "Admin",
    link: "/admin",
    sub: [
        {
            menu: 'Common',
            link: "#",
            sub: [
                {
                    link: "/admin/home/business-profile",
                    menu: "Business Profile",
                },
                {
                    link: "/admin/home/team",
                    menu: "Team Management",
                },
                {
                    link: "/admin/home/billings",
                    menu: "Billing and Plans",
                },
            ]
        },
        {
            menu: 'Batch Process',
            link: "#",
            sub: [
                {
                    link: "/admin/batch-process/price-list/outbound",
                    menu: "Outbound Price List",
                },
                {
                    link: "/admin/batch-process/price-list/inbound",
                    menu: "Inbound Price List",
                },
                {
                    link: "/admin/batch-process/schedule-transactions",
                    menu: "Schedule Transactions",
                }
            ]
        },
        {
            menu: 'Report & Enquiry',
            link: "#",
            sub: [
                {
                    link: "/admin/report-enquiry/gst-transactions",
                    menu: "GST Detailed Transaction Report",
                },
                {
                    link: "/admin/report-enquiry/gstr1-hsn-detailed-report",
                    menu: "GSTR- HSN-Detailed report",
                },
                {
                    link: "/admin/report-enquiry/gstr1-summary-report",
                    menu: "GSTR-Summary-Tax rate split",
                },
                {
                    link: "/admin/report-enquiry/gstr1-hsn-summary-report",
                    menu: "GSTR-Summary-Tax rate and HSN Split",
                },
                {
                    link: "/gst-summary-report",
                    menu: "GST Summary Report",
                },
                {
                    link: "/admin/report-enquiry/delivery-details",
                    menu: "Delivery Details",
                },
                {
                    link: "/admin/report-enquiry/tax-transactions",
                    menu: "Tax Detailed Transaction Report",
                },
            ]
        },
        {
            menu: 'Setup',
            link: "#",
            sub: [
                {
                    link: "/admin/setup/activity-prefix-counter",
                    menu: "Activity Prefix Counter"
                },
                {
                    link: "/admin/parameters",
                    menu: "Parameters"
                },
                {
                    link: "/admin/setup/hsn-code",
                    menu: "HSN Code",
                    sub: false
                },
                {
                    link: "/admin/setup/tax-code",
                    menu: "Tax Code",
                    sub: false
                },
                {
                    link: "/admin/setup/other-taxes",
                    menu: "Other Taxes",
                    sub: false
                },
                {
                    link: "/admin/setup/cash-discount",
                    menu: "Cash Discount",
                    sub: false
                },
                {
                    menu: "Address",
                    link: "#",
                    sub: [
                        {
                            link: "/admin/address/country",
                            menu: "Country",
                        },
                        {
                            link: "/admin/address/state",
                            menu: "State",
                        },
                        {
                            link: "/admin/address/city",
                            menu: "City",
                        },
                        {
                            link: "/admin/address/pincode",
                            menu: "Pincode",
                        },
                        {
                            link: "/admin/address/area",
                            menu: "Area",
                        },
                    ]
                },
                {
                    menu: "Units",
                    link: "#",
                    sub: [
                        {
                            link: "/admin/setup/units/unit-class",
                            menu: "Unit Class",
                        },
                        {
                            link: "/admin/setup/units/unit-measurement",
                            menu: "Unit of Measurement",
                        },
                        {
                            link: "/admin/setup/units/unit-conversions",
                            menu: "Unit Conversions",
                        }
                    ]
                },
            ]
        }
    ]
}

export const helpMenus = [
    {
        menu: "User Guide Docs",
        sub: [
            {
                menu: "Application Registration & Login",
                type: "Pdf View",
                pdf: `${process.env.REACT_APP_ASSET_ROOT_URL}/v1/fileprocessor/getFileAsAttachement/?fileUri=public/pdf/Application+Registration+%26+Login.pdf`
            },
            {
                menu: "Business Profile Update", type: "Pdf View",
                pdf: `${process.env.REACT_APP_ASSET_ROOT_URL}/v1/fileprocessor/getFileAsAttachement/?fileUri=public/pdf/Business+Profile+Update.pdf`
            },
            {
                menu: "Product Setup", type: "Pdf View",
                pdf: `${process.env.REACT_APP_ASSET_ROOT_URL}/v1/fileprocessor/getFileAsAttachement/?fileUri=public/pdf/Product+Setup.pdf`
            },
            {
                menu: "Customer Setup", type: "Pdf View", pdf: `${process.env.REACT_APP_ASSET_ROOT_URL}/v1/fileprocessor/getFileAsAttachement/?fileUri=public/pdf/Customer+Setup.pdf`
            },
            {
                menu: "Supplier Setup", type: "Pdf View", pdf: `${process.env.REACT_APP_ASSET_ROOT_URL}/v1/fileprocessor/getFileAsAttachement/?fileUri=public/pdf/Supplier+Setup.pdf`
            },
            {
                menu: "Raise a Sales Invoice or Bill", type: "Pdf View", pdf: `${process.env.REACT_APP_ASSET_ROOT_URL}/v1/fileprocessor/getFileAsAttachement/?fileUri=public/pdf/Raise+a+Sales+Invoice+or+Bill.pdf`
            },
            {
                menu: "Record Supplier Invoice or Bill", type: "Pdf View", pdf: `${process.env.REACT_APP_ASSET_ROOT_URL}/v1/fileprocessor/getFileAsAttachement/?fileUri=public/pdf/Record+Supplier+Invoice+or+Bill.pdf`
            },
            {
                menu: "Customer Payment", type: "Pdf View", pdf: `${process.env.REACT_APP_ASSET_ROOT_URL}/v1/fileprocessor/getFileAsAttachement/?fileUri=public/pdf/Customer+Payment.pdf`
            },
            {
                menu: "Supplier Payment", type: "Pdf View", pdf: `${process.env.REACT_APP_ASSET_ROOT_URL}/v1/fileprocessor/getFileAsAttachement/?fileUri=public/pdf/Supplier+Payment.pdf`
            },
            {
                menu: "Sales Price Setup", type: "Pdf View", pdf: `${process.env.REACT_APP_ASSET_ROOT_URL}/v1/fileprocessor/getFileAsAttachement/?fileUri=public/pdf/Sales+Price+Setup.pdf`
            }
        ]
    },
    {
        menu: "User Guide Videos",
        sub: [
            {
                menu: "Product Setup",
                type: "Video View",
                pdf: "UW0M-EtXCm4",
            },
            {
                menu: "Adding Your Customers and Suppliers",
                type: "Video View",
                pdf: "t3FBmbq9z2U",
            },
            {
                menu: "Raising a Sales Invoice or Bill",
                type: "Video View",
                pdf: "AJ0VqEiGqDI",
            },
            {
                menu: "Recording a Supplier Invoice or Bill",
                type: "Video View",
                pdf: "Kjmb6QCC-j0",
            },
            {
                menu: "Recording Your Customer Payment",
                type: "Video View",
                pdf: "uE4bjS80lUY",
            },
            {
                menu: "Recording Your Supplier Payment",
                type: "Video View",
                pdf: "pD6nOaMenH0",
            },
            {
                menu: "Retail Store Sales Billing",
                type: "Video View",
                pdf: "H9V789pzPvo",
            },
            {
                menu: "Sales and Purchase Price Setup",
                type: "Video View",
                pdf: "qVvfvtrbpkU",
            },
        ]
    },
    {
        menu: "Shortcut Keys"
    },
]

export const younoteAdminMenus = {
    menu: "Younote Admin",
    link: "/younote-admin",
    sub: [
        {
            menu: 'Common',
            link: "#",
            sub: [
                {
                    link: "/younote-admin/common/brands",
                    menu: "Brands",
                },
                {
                    link: "/younote-admin/common/catalogue",
                    menu: "Catalogue",
                },
                {
                    link: "/younote-admin/common/products",
                    menu: "Universal Products",
                },
                {
                    link: "/younote-admin/common/universal-catalogue",
                    menu: "Universal Catalogue",
                },
                {
                    link: "/younote-admin/home/global-address-book",
                    menu: "Global Address Book",
                },
                {
                    link: "/younote-admin/common/plan-details",
                    menu: "Plan Details",
                },
                {
                    link: "/younote-admin/common/subscription-provider",
                    menu: "Subscription Provider",
                }
            ]
        },
        {
            menu: 'Batch Process / Jobs',
            link: "#",
            sub: [
                {
                    link: "#",
                    menu: "Run Planning",
                }
            ]
        },
        {
            menu: 'Setup',
            link: "#",
            sub: [
                {
                    link: "/younote-admin/setup/global-parameters",
                    menu: "Global Parameters",
                    sub: false
                },
                {
                    link: "/younote-admin/setup/reject-reason",
                    menu: "Reason Codes",
                    sub: false
                },
                {
                    link: "/younote-admin/setup/method-of-payment",
                    menu: "Method of Payment",
                    sub: false
                },
                {
                    link: "/younote-admin/setup/digital-wallet",
                    menu: "Digital Wallet",
                    sub: false
                },
                {
                    link: "/younote-admin/setup/tax-setup",
                    menu: "Tax Setup",
                    sub: false
                },
                {
                    link: "/younote-admin/setup/party-gst-code",
                    menu: "Party GST Code",
                    sub: false
                },
                {
                    link: "/younote-admin/setup/product-gst-code",
                    menu: "Product GST Code",
                    sub: false
                },
                {
                    link: "/younote-admin/setup/tax-code",
                    menu: "Tax Code",
                    sub: false
                },
                {
                    link: "/younote-admin/setup/other-taxes",
                    menu: "Other Taxes",
                    sub: false
                },
                {
                    link: "/younote-admin/setup/cash-discount",
                    menu: "Cash Discount",
                    sub: false
                },
                {
                    link: "/younote-admin/setup/hsn-code",
                    menu: "HSN Code",
                    sub: false
                },
                {
                    link: "/younote-admin/setup/currency",
                    menu: "Currency",
                    sub: false
                },
                {
                    link: "/younote-admin/setup/workflow",
                    menu: "Schedule Workflow",
                    sub: false
                },
                {
                    link: "/younote-admin/setup/schedule-frequency",
                    menu: "Schedule Frequency",
                    sub: false
                },
                {
                    menu: "Address",
                    link: "#",
                    sub: [
                        {
                            link: "/younote-admin/address/country",
                            menu: "Country",
                        },
                        {
                            link: "/younote-admin/address/state",
                            menu: "State",
                        },
                        {
                            link: "/younote-admin/address/city",
                            menu: "City",
                        },
                        {
                            link: "/younote-admin/address/pincode",
                            menu: "Pincode",
                        },
                        {
                            link: "/younote-admin/address/area",
                            menu: "Area",
                        },
                    ]
                },
                {
                    menu: "Units",
                    link: "#",
                    sub: [
                        {
                            link: "/younote-admin/setup/units/unit-class",
                            menu: "Unit Class",
                        },
                        {
                            link: "/younote-admin/setup/units/unit-measurement",
                            menu: "Unit of Measurement",
                        },
                        {
                            link: "/younote-admin/setup/units/unit-conversions",
                            menu: "Unit Conversions",
                        }
                    ]
                },
            ]
        },
        {
            menu: 'Security Setup',
            link: "#",
            sub: [
                {
                    link: "/younote-admin/setup/activity-prefix-management",
                    menu: "Activity Prefix Management",
                    sub: false
                },
                {
                    link: "/younote-admin/setup/activity-prefix-counter",
                    menu: "Global Activity Prefix Counter",
                    sub: false
                },
                {
                    link: "/younote-admin/security-setup/module-list",
                    menu: "Module List",
                },
                {
                    link: "/younote-admin/security-setup/component-type",
                    menu: "Component Type",
                },
                {
                    link: "/younote-admin/security-setup/feature-list",
                    menu: "Feature List",
                },
                {
                    link: "/younote-admin/security-setup/security-roles",
                    menu: "Security Roles",
                }
            ]
        }
    ]
}

export const profileMenus = {
    menu: "Profile",
    icon: ProfileIcon,
    sub: [
        {
            menu: 'My Profile',
            link: '/my-profile',
        },
        {
            menu: 'Logout',
            link: '/logout',
        },
        {
            menu: 'Change Password',
            link: '/change-password',
        },
        {
            menu: 'Change Email ID',
            link: '/change-email-id',
        },
        {
            menu: 'Change Mobile Number',
            link: '/change-mobile-number',
        },
        {
            menu: 'Change Language',
            link: '/change-language',
        }
    ]
}

//Team
// export const teamHead = ['Full Name', 'Mobile', 'Email', 'Role', 'Status', 'Actions']


export const teamHead = [
    { 'key': 'name', 'name': 'Full Name', 'sorting': true },
    { 'key': 'mobile', 'name': 'Mobile', 'sorting': true },
    { 'key': 'email', 'name': 'Email', 'sorting': true },
    { 'key': 'role', 'name': 'Role' },
    { 'key': 'status', 'name': 'Status', 'sorting': true },
    { 'key': 'actions', 'name': 'Actions' },
];


export const deliveryCustomerDetails = [
    { 'key': 'checkbox', 'name': 'Checkbox' },
    { 'key': 'customerName', 'name': 'Customer Name', 'sorting': true },
    { 'key': 'customerID', 'name': 'Customer ID' },
    { 'key': 'serialNo', 'name': 'Invoice Number', 'sorting': true },
    { 'key': 'invoiceDate', 'name': 'Invoice Date', 'sorting': true },
    { 'key': 'reference', 'name': 'Reference' },
    { 'key': 'qunantity', 'name': 'Total Del. Quantity' },
    { 'key': 'pincode', 'name': 'PIN Code' },
    { 'key': 'placeSupply', 'name': 'Place Of Supply' },
    { 'key': 'actions', 'name': 'Actions' },
];

//Address
export const countryHead =
    [
        { 'key': 'name', 'name': 'Country Name', 'sorting': true },
        { 'key': 'longName', 'name': 'Long Name', 'sorting': true },
        { 'key': 'currencyName', 'name': 'Currency Name' },
        { 'key': 'currencySymbol', 'name': 'Currency Symbol' },
        { 'key': 'actions', 'name': 'Actions' }
    ];
export const stateHead =
    [
        { 'key': 'name', 'name': 'State Name', 'sorting': true },
        { 'key': 'shortName', 'name': 'Short Name', 'sorting': true },
        { 'key': 'countryName', 'name': 'Country', 'relation': 'countryDetails' },
        { 'key': 'isUtgst', 'name': 'IS UTGST', 'sorting': true },
        { 'key': 'action', 'name': 'Actions' },
    ];
export const cityHead =
    [
        { 'key': 'name', 'name': 'City Name', 'sorting': true },
        { 'key': 'state', 'name': 'State' },
        { 'key': 'country', 'name': 'Country' },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const areaHead = [
    { 'key': 'name', 'name': 'Area Name', 'sorting': true },
    { 'key': 'pincodeId', 'name': 'Pincode' },
    { 'key': 'cityId', 'name': 'City Name' },
    { 'key': 'stateId', 'name': 'State' },
    { 'key': 'countryId', 'name': 'Country' },
    { 'key': 'action', 'name': 'Actions' }
];

export const pincodeHead =
    [
        { 'key': 'code', 'name': 'Code', 'sorting': true },
        { 'key': 'cityId', 'name': 'City Name' },
        { 'key': 'stateId', 'name': 'State' },
        { 'key': 'countryId', 'name': 'Country' },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const productGSTHead =
    [
        { 'key': 'code', 'name': 'Product GST Code', 'sorting': true },
        { 'key': 'description', 'name': 'Description', 'sorting': true },
        { 'key': 'percentage', 'name': 'Percentage', 'sorting': true },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const taxCodeHead =
    [
        { 'key': 'code', 'name': 'Tax Code', 'sorting': true },
        { 'key': 'description', 'name': 'Description', 'sorting': true },
        { 'key': 'percentage', 'name': 'Percentage', 'sorting': true },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const cashDiscountHead =
    [
        { 'key': 'code', 'name': 'Code', 'sorting': true },
        { 'key': 'description', 'name': 'Description', 'sorting': true },
        { 'key': 'percentage', 'name': 'Percentage', 'sorting': true },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const otherTaxesHead =
    [
        { 'key': 'type', 'name': 'Type', 'sorting': true },
        { 'key': 'name', 'name': 'Name', 'sorting': true },
        { 'key': 'percentage', 'name': 'Percentage', 'sorting': true },
        { 'key': 'threshold', 'name': 'Threshold', 'sorting': true },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const partyGSTHead =
    [
        { 'key': 'code', 'name': 'Party GST Code', 'sorting': true },
        { 'key': 'description', 'name': 'Description', 'sorting': true },
        { 'key': 'additionalText', 'name': 'Text', 'sorting': true },
        { 'key': 'isSEZ', 'name': 'SEZ', 'sorting': true },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const hsnHead =
    [
        { 'key': 'hsnCode', 'name': 'HSN Code', 'sorting': true },
        { 'key': 'description', 'name': 'Description', 'sorting': true },
        { 'key': 'chapter', 'name': 'Chapter', 'sorting': true },
        { 'key': 'productGst', 'name': 'Product GST Code', 'sorting': true },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const moduleHead =
    [
        { 'key': 'module', 'name': 'Modules', 'sorting': true },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const featureHead =
    [
        { 'key': 'featureName', 'name': 'Feature', 'sorting': true },
        { 'key': 'description', 'name': 'Description', 'sorting': true },
        { 'key': 'module', 'name': 'Module' },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const featureModuleHead =
    [
        { 'key': 'featureName', 'name': 'Feature', 'sorting': true },
        { 'key': 'description', 'name': 'Description', 'sorting': true },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const componentHead =
    [
        { 'key': 'componentType', 'name': 'Component Type', 'sorting': true },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const productHead =
    [
        { 'key': 'productId', 'name': 'Product ID', 'sorting': true },
        { 'key': 'productName', 'name': 'Product Name', 'sorting': true },
        { 'key': 'type', 'name': 'Product Type', 'sorting': true },
        { 'key': 'skuQuantity', 'name': 'SKU Quantity', 'sorting': true },
        { 'key': 'unit', 'name': 'Unit' },
        { 'key': 'hsnCode', 'name': 'HSN Code' },
        { 'key': 'productGST', 'name': 'Product GST' },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "81px" }
    ];

export const rejectHead =
    [
        { 'key': 'rejectReasonCode', 'name': 'Codes', 'sorting': true },
        { 'key': 'rejectReasonDesc', 'name': 'Description', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "81px" }
    ];

export const taxHead =
    [
        { 'key': 'country', 'name': 'Country Name' },
        { 'key': 'name', 'name': 'Tax Name', 'sorting': true },
        { 'key': 'description', 'name': 'Description', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "81px" }
    ];

export const taxSetupHead =
    [
        { 'key': 'taxCode', 'name': 'Tax Id', 'sorting': true },
        { 'key': 'name', 'name': 'Tax Type', 'sorting': true },
        { 'key': 'isDefault', 'name': 'Default' },
        { 'key': 'partyGst', 'name': 'Party Gst' },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "81px", rightAlign: "true" }
    ];

export const brandHead =
    [
        { 'key': 'brandName', 'name': 'Name', 'sorting': true },
        { 'key': 'brandShortName', 'name': 'Short Name', 'sorting': true },
        { 'key': 'description', 'name': 'Description', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "81px" }
    ];

export const workflowHead =
    [
        { 'key': 'name', 'name': 'Name', 'sorting': true },
        { 'key': 'description', 'name': 'Description', 'sorting': true },
        { 'key': 'action', 'name': 'Action', 'sorting': true },
        { 'key': 'actionStatus', 'name': 'Action Status', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "81px" }
    ];

export const frequencyHead =
    [
        { 'key': 'name', 'name': 'Name', 'sorting': true },
        { 'key': 'description', 'name': 'Description', 'sorting': true },
        { 'key': 'repeatType', 'name': 'Repeat Type', 'sorting': true },
        { 'key': 'occurenceCount', 'name': 'Occurence Count', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "81px" }
    ];

export const paymentHead =
    [
        { 'key': 'paymentId', 'name': 'Order Number' },
        { 'key': 'paymentId', 'name': 'Payment Id' },
        { 'key': '', 'name': 'Date' },
        { 'key': '', 'name': 'Amount' },
        { 'key': '', 'name': 'Status' },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "50px" }
    ];

export const providerHead =
    [
        { 'key': 'providerId', 'name': 'Provider ID', 'sorting': true },
        { 'key': 'name', 'name': 'Subscription Provider', 'sorting': true },
        { 'key': 'type', 'name': 'Type', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "81px" }
    ];

export const planHead =
    [
        { 'key': 'providerId', 'name': 'Plan ID', 'sorting': true },
        { 'key': 'planName', 'name': 'Plan Name', 'sorting': true },
        { 'key': 'actualPlanAmount', 'name': 'Actual Plan Amount', 'sorting': true, rightAlign: "true" },
        { 'key': 'planAmount', 'name': 'Plan Amount', 'sorting': true, rightAlign: "true" },
        { 'key': 'allowedUsers', 'name': 'Allowed User', 'sorting': true },
        { 'key': 'providerId', 'name': 'Subscription Provider' },
        { 'key': 'providerId', 'name': 'Subs Provider ID' },
        { 'key': 'frequency', 'name': 'Frequency', 'sorting': true },
        { 'key': 'status', 'name': 'Status', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "81px" }
    ];

export const bulkPublishHead =
    [
        { 'key': 'batchId', 'name': 'Batch Id', 'sorting': true },
        { 'key': 'createdBy', 'name': 'Created By' },
        { 'key': 'createTs', 'name': 'Created Date', 'sorting': true },
        { 'key': 'createTs', 'name': 'Created Time', 'sorting': true },
        { 'key': 'status', 'name': 'Status' },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "55px" }
    ];

export const scheduledTransactionsHead =
    [
        { 'key': 'serial_no', 'name': 'Batch Id', 'sorting': true },
        { 'key': 'customerName', 'name': 'Customer Name' },
        { 'key': 'dateofSchedule', 'name': 'Date of Schedule' },
        { 'key': 'createBy', 'name': 'Created By' },
        { 'key': 'createTs', 'name': 'Created Date' },
        { 'key': 'createTs', 'name': 'Created Time' },
        { 'key': 'isAutomated', 'name': 'Is Automated' },
        { 'key': 'status', 'name': 'Status' },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "55px" }
    ];

export const myProductHead =
    [
        { 'key': 'productName', 'name': 'Product Name', 'sorting': true },
        { 'key': 'description', 'name': 'Description', 'sorting': true },
        { 'key': 'productId', 'name': 'Product ID', 'sorting': true },
        { 'key': 'categoryId', 'name': 'Category Name' },
        { 'key': 'skuQuantity', 'name': 'SKU Quantity', 'sorting': true },
        { 'key': 'skuUnitId', 'name': 'SKU Unit' },
        { 'key': 'salesUnitId', 'name': 'Sales Unit' },
        { 'key': 'hsnCode', 'name': 'HSN Code' },
        { 'key': 'productGST', 'name': 'Product GST' },
        { 'key': 'status', 'name': 'Status', 'sorting': true },
        { 'key': 'code', 'name': 'Product Code', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "81px" }
    ];

export const stockTransactionHead =
    [
        { 'key': 'product', 'name': 'Product Name', 'sorting': true },
        { 'key': 'productId', 'name': 'Product ID', 'sorting': true },
        { 'key': 'soldUnit', 'name': 'Sold Unit', 'sorting': true },
        { 'key': 'SoldQuantity', 'name': 'Sold Quantity', 'rightAlign': true },
        { 'key': 'SoldAmount', 'name': 'Sold Amount', 'rightAlign': true },
        { 'key': 'PurchaseUnit', 'name': 'Purchase Unit' },
        { 'key': 'PurchaseQuantity', 'name': 'Purchase Quantity', 'rightAlign': true },
        { 'key': 'PurchaseAmount', 'name': 'Purchase Amount', 'rightAlign': true },
        { 'key': 'SoldQuantity', 'name': 'Available quantity', 'centerAlign': true },
        { 'key': 'avgPrice', 'name': 'Avg Price', 'rightAlign': true },
        { 'key': 'stockValue', 'name': 'Stock Value', 'rightAlign': true }
    ];

export const inventoryTransactionHead =
    [
        { 'key': 'inventory_lot', 'name': 'Lot ID', 'sorting': true },
        { 'key': 'transactionDate', 'name': 'Date', 'sorting': true },
        { 'key': 'product', 'name': 'Product Name' },
        { 'key': 'productId', 'name': 'Product ID' },
        { 'key': 'productId', 'name': 'Product Code' },
        { 'key': 'reference_type', 'name': 'Source', 'sorting': true },
        { 'key': 'quantity', 'name': 'Stock Quantity', 'sorting': true },
        { 'key': 'unitId', 'name': 'Stock Unit' },
        { 'key': 'billQuantity', 'name': 'Bill Quantity', 'sorting': true },
        { 'key': 'billUnitId', 'name': 'Bill Unit' },
        { 'key': 'locationId', 'name': 'Location' },
        { 'key': 'batchId', 'name': 'Batch' },
        { 'key': 'inventory_status', 'name': 'Status', 'sorting': true },
        { 'key': 'cost_per_unit', 'name': 'Cost per unit', 'sorting': true },
        { 'key': 'price_per_unit', 'name': 'Price per unit', 'sorting': true },
        { 'key': 'line_amount', 'name': 'Amount', 'sorting': true },
        { 'key': 'party_name', 'name': 'Party name', 'sorting': true },
        { 'key': 'financial_reference', 'name': 'Financial reference', 'sorting': true },
        { 'key': 'serialNo', 'name': 'Party ID' },
        { 'key': 'name', 'name': 'Party Name' },
        { 'key': 'orderNo', 'name': 'Party Order No' },
        { 'key': 'orderLineNo', 'name': 'Party Order Line No' },
        { 'key': 'serviceRef', 'name': 'Service Ref' },
        { 'key': 'productRef', 'name': 'Product Ref' },
        { 'key': 'productRef', 'name': 'Party Order Line Amount' }
    ];

export const batchNumbersHead =
    [
        { 'key': 'batchNumber', 'name': 'Batch Number', 'sorting': true },
        { 'key': 'product', 'name': 'Product Name' },
        { 'key': 'productId', 'name': 'Product ID' },
        { 'key': 'productId', 'name': 'Product Code' },
        { 'key': 'manufacturingDate', 'name': 'Manufacturing Date', 'sorting': true },
        { 'key': 'expiryDate', 'name': 'Expiry Date', 'sorting': true },
        { 'key': 'useByDate', 'name': 'Use By Date', 'sorting': true },
        { 'key': 'bestBeforeDate', 'name': 'Best Before Date', 'sorting': true },
        { 'key': 'purchaseQuantity', 'name': 'Purchase Quantity', 'sorting': true },
        { 'key': 'purchasePrice', 'name': 'Purchase Price', 'sorting': true },
        { 'key': 'perUnitPrice', 'name': 'Per Unit Price', 'sorting': true },
        { 'key': 'mrp', 'name': 'MRP', 'sorting': true },
        { 'key': 'soldQuantity', 'name': 'Sold Quantity', 'sorting': true },
        { 'key': 'availableStock', 'name': 'Available Stock', 'sorting': true },
        { 'key': 'reference_type', 'name': 'Reference Type', 'sorting': true },
        { 'key': 'unitId', 'name': 'Unit' },
        { 'key': 'locationId', 'name': 'Location' }
    ];

export const stockOnHandHead =
    [
        { 'key': 'productId', 'name': 'Product Name' },
        { 'key': 'physicalQtyUnit', 'name': 'Unit Quantity' },
        { 'key': 'unitId', 'name': 'Unit' },
        { 'key': 'physicalQtyUnit', 'name': 'SKU Quantity' },
        { 'key': 'unitId', 'name': 'SKU Unit' },
        { 'key': 'Cost Amount', 'name': 'Cost Amount' },
        { 'key': '', 'name': 'Actions', 'actionWidth': '60px' },
    ];

export const myProductHeadProduct =
    [
        { 'key': 'checkbox', 'name': 'Checkbox' },
        { 'key': 'productName', 'name': 'Product Name', 'sorting': true },
        { 'key': 'productId', 'name': 'Product ID', 'sorting': true },
        { 'key': 'category', 'name': 'Category' },
        { 'key': 'type', 'name': 'Product Type', 'sorting': true },
        { 'key': 'skuQuantity', 'name': 'S.Qty', 'sorting': true },
        { 'key': 'skuUnitId', 'name': 'SKU Unit' },
        { 'key': 'salesUnitId', 'name': 'Sales Unit' },
        { 'key': 'hsnCode', 'name': 'HSN Code' },
        { 'key': 'productGST', 'name': 'Product GST' },
    ];

export const myProductHeadProductPrev =
    [
        { 'key': 'productName', 'name': 'Product Name' },
        { 'key': 'productId', 'name': 'Product ID' },
        { 'key': 'category', 'name': 'Category' },
        { 'key': 'type', 'name': 'Product Type' },
        { 'key': 'skuQuantity', 'name': 'SKU Quantity' },
        { 'key': 'skuUnitId', 'name': 'SKU Unit' },
        { 'key': 'salesUnitId', 'name': 'Sales Unit' },
        { 'key': 'hsnCode', 'name': 'HSN Code' },
        { 'key': 'productGST', 'name': 'Product GST' },
        { 'key': '', 'name': 'Actions' },
    ];

export const methodofPaymentHead = [
    { 'key': 'method', 'name': 'Method Of Payment', 'sorting': true },
    { 'key': 'description', 'name': 'Description', 'sorting': true },
    { 'key': 'action', 'name': 'Actions' }
];

export const digitalWalletHead = [
    { 'key': 'name', 'name': 'Digital Wallet', 'sorting': true },
    { 'key': 'description', 'name': 'Description', 'sorting': true },
    { 'key': 'action', 'name': 'Actions' }
];

export const currencyHead = [
    { 'key': 'name', 'name': 'Currency', 'sorting': true },
    { 'key': 'shortName', 'name': 'Short Name', 'sorting': true },
    { 'key': 'symbol', 'name': 'Symbol', 'sorting': true },
    { 'key': 'action', 'name': 'Actions' }
];

export const unitClassHead =
    [
        { 'key': 'name', 'name': 'Unit Class Name', 'sorting': true },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const unitConversionHead =
    [
        { 'key': 'id', 'name': 'Id', 'sorting': true },
        { 'key': 'name', 'name': 'Unit' },
        { 'key': 'name', 'name': 'To Unit' },
        { 'key': 'conversionFactor', 'name': 'Conversion Factor', 'sorting': true },
        { 'key': 'additionalFactor', 'name': 'Addition Factor', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': '81px' }
    ];

export const scheduleLinesHead =
    [
        { 'key': 'product', 'name': 'Product' },
        { 'key': 'product', 'name': 'Product ID' },
        { 'key': 'additionalFactor', 'name': 'Quantity' },
        { 'key': 'unit', 'name': 'Unit' },
        { 'key': 'unit', 'name': 'Amount', 'rightAlign': true }
    ];

export const productUnitConversionHead =
    [
        { 'key': 'id', 'name': 'Id', 'sorting': true },
        { 'key': 'productName', 'name': 'Product Name' },
        { 'key': 'productId', 'name': 'Product ID' },
        { 'key': 'name', 'name': 'Unit' },
        { 'key': 'name', 'name': 'To Unit' },
        { 'key': 'conversionFactor', 'name': 'Conversion Factor', 'sorting': true },
        { 'key': 'additionalFactor', 'name': 'Addition Factor', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': '81px' }
    ];

export const clientsHead =
    [
        { 'key': 'younoteId', 'name': 'Younote ID' },
        { 'key': 'phone', 'name': 'Phone' },
        { 'key': 'name', 'name': 'Name' },
        { 'key': 'connect', 'name': 'Connect' }
    ];

export const unitMesurementdetailsHead =
    [
        { 'key': 'name', 'name': 'Unit', 'sorting': true },
        { 'key': 'description', 'name': 'Description', 'sorting': true },
        { 'key': 'unitClass', 'name': 'Unit Class' },
        { 'key': 'systemOfUnits', 'name': 'System of Units', 'sorting': true },
        { 'key': 'precision', 'name': 'Decimal Precision', 'sorting': true },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const customerGroupHead =
    [
        { 'key': 'name', 'name': 'Customer Group', 'sorting': true },
        { 'key': 'description', 'name': 'Description', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': '81px' }
    ];

export const customerProductsHead =
    [
        { 'key': 'name', 'name': 'Customer Name' },
        { 'key': 'serialNumber', 'name': 'Customer ID' },
        { 'key': 'count', 'name': 'Product Count' },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': '81px' }
    ];

export const productGroupHead =
    [
        { 'key': 'name', 'name': 'Product Group', 'sorting': true },
        { 'key': 'description', 'name': 'Description', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': '81px' }
    ];
export const locationHead =
    [
        { 'key': 'name', 'name': 'Name', 'sorting': true },
        { 'key': 'default', 'name': 'Default' },
        { 'key': 'address', 'name': 'Address' },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': '81px' }
    ];

export const supplierGroupHead =
    [
        { 'key': 'name', 'name': 'Supplier Group', 'sorting': true },
        { 'key': 'description', 'name': 'Description', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': '81px' }
    ];


export const securityRolesHead =
    [
        { 'key': 'name', 'name': 'Role Name' },
        { 'key': 'Mapped Feature', 'name': 'Mapped Feature' },
        { 'key': 'Tagged to Clients', 'name': 'Tagged to Clients' },
        { 'key': 'Assigned to Users', 'name': 'Assigned to Users' },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': '110px' }
    ];

export const featureListHead =
    [
        { 'key': 'Feature', 'name': 'Feature' },
        { 'key': 'Modules', 'name': 'Modules' },
        { 'key': 'action', 'name': 'Actions' }
    ];


export const globalAddressHead =
    [
        { 'key': 'name', 'name': 'Name' },
        { 'key': 'mobile', 'name': 'Mobile Number' },
        { 'key': 'email', 'name': 'Email' },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': true }
    ];

export const allCustomerHead =
    [
        { 'key': 'name', 'name': 'Name', 'sorting': true },
        { 'key': 'serialNo', 'name': 'ID', 'sorting': true },
        { 'key': 'mobile', 'name': 'Ph. Number', 'sorting': true },
        { 'key': 'group', 'name': 'Group' },
        { 'key': 'classification', 'name': 'Classification' },
        { 'key': 'status', 'name': 'In App Status' },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "110px" }
    ];

export const billLineHead = [
    { 'key': 'lineNo', 'name': 'L. No.' },
    { 'key': 'description', 'name': 'Description' },
    { 'key': 'quantity', 'name': 'Qty.' },
    { 'key': 'unit', 'name': 'Unit' },
    { 'key': 'unitPrice', 'name': 'Unit Price', 'rightAlign': true },
    { 'key': 'discountAmount', 'name': 'Discount Amount', 'rightAlign': true },
    { 'key': 'lineAmount', 'name': 'Line Amount', 'rightAlign': true },
    { 'key': 'excisesTotal', 'name': 'Excise Total', 'rightAlign': true },
    { 'key': 'gstCode', 'name': 'GST Code' },
    { 'key': 'gstAmount', 'name': 'GST Amount', 'rightAlign': true },
    { 'key': 'actions', 'name': 'Actions', 'rightAlign': true }
];

export const adjustLineHead = [
    { 'key': 'checkbox', 'name': 'Checkbox' },
    { 'key': 'lineNo', 'name': 'L. No.' },
    { 'key': 'productId', 'name': 'Product Description' },
    { 'key': 'productId', 'name': 'Product ID' },
    { 'key': 'unit', 'name': 'Unit' },
    { 'key': 'quantity', 'name': 'Quantity', 'centerAlign': true },
    { 'key': 'unitPrice', 'name': 'Cost Price', 'rightAlign': true },
    { 'key': 'amount', 'name': 'Total Cost Price', 'rightAlign': true },
    { 'key': 'locationId', 'name': 'Location' },
    { 'key': 'mrp', 'name': 'MRP' },
    { 'key': 'batch', 'name': 'Batch' },
    { 'key': 'productId', 'name': 'Product Name' },
    { 'key': 'actions', 'name': 'Actions', 'rightAlign': true }
];

export const countLineHead = [
    { 'key': 'checkbox', 'name': 'Checkbox' },
    { 'key': 'lineNo', 'name': 'L. No.' },
    { 'key': 'productId', 'name': 'Product Name' },
    { 'key': 'productId', 'name': 'Product ID' },
    { 'key': 'unit', 'name': 'Unit' },
    { 'key': 'currentStock', 'name': 'Current Stock' },
    { 'key': 'countedQuantity', 'name': 'Counted quantity' },
    { 'key': 'unitPrice', 'name': 'Cost Price', 'rightAlign': true },
    { 'key': 'locationId', 'name': 'Location' },
    { 'key': 'actions', 'name': 'Actions', 'rightAlign': true }
];

export const transferLineHead = [
    { 'key': 'checkbox', 'name': 'Checkbox' },
    { 'key': 'lineNo', 'name': 'L. No.' },
    { 'key': 'productId', 'name': 'Product Name' },
    { 'key': 'productId', 'name': 'Product ID' },
    { 'key': 'unit', 'name': 'Unit' },
    { 'key': 'locationId', 'name': 'Location' },
    { 'key': 'quantity', 'name': 'Current Stock' },
    { 'key': 'toQuantity', 'name': 'Shipped  Quantity' },
    { 'key': 'receivedQuantity', 'name': 'Received  Quantity' },
    { 'key': 'balanceQuantity', 'name': 'Balance  Quantity' },
    { 'key': 'unitPrice', 'name': 'Cost Price', 'rightAlign': true },
    { 'key': 'toLocationId', 'name': 'To Location' },
    { 'key': 'lineStatus', 'name': 'Status' },
    { 'key': 'actions', 'name': 'Actions', 'rightAlign': true }
];

export const orderLineHead = [
    { 'key': 'lineNo', 'name': 'L. No.' },
    { 'key': 'description', 'name': 'Description' },
    { 'key': 'quantity', 'name': 'Qty.' },
    { 'key': 'unit', 'name': 'Unit' },
    { 'key': 'unitPrice', 'name': 'Unit Price', 'rightAlign': true },
    { 'key': 'discountAmount', 'name': 'Discount Amount', 'rightAlign': true },
    { 'key': 'lineAmount', 'name': 'Line Amount', 'rightAlign': true },
    { 'key': 'excisesTotal', 'name': 'Excise Total', 'rightAlign': true },
    { 'key': 'gstCode', 'name': 'GST Code' },
    { 'key': 'gstAmount', 'name': 'GST Amount', 'rightAlign': true },
    { 'key': 'lineStatus', 'name': 'Status' },
    { 'key': 'actions', 'name': 'Actions', 'rightAlign': true }
];

export const deliveryLineHead = [
    { 'key': 'id', 'name': 'Select' },
    { 'key': 'lineNo', 'name': 'L. No.' },
    { 'key': 'description', 'name': 'Description' },
    { 'key': 'quantity', 'name': 'Qty.' },
    { 'key': 'unit', 'name': 'Unit' },
    { 'key': 'unitPrice', 'name': 'Unit Price', 'rightAlign': true },
    { 'key': 'discountAmount', 'name': 'Discount Amount', 'rightAlign': true },
    { 'key': 'lineAmount', 'name': 'Line Amount', 'rightAlign': true },
    { 'key': 'deliver_quantity', 'name': 'Delivered' },
    { 'key': 'available_quantity', 'name': 'Remaining' },
    { 'key': 'deliver_quantity', 'name': 'Deliver Now' },
    { 'key': 'batch', 'name': 'Batch' },
    { 'key': 'actions', 'name': 'Actions', 'rightAlign': true }
];


export const deliveryLineHeadView = [
    { 'key': 'lineNo', 'name': 'L. No.' },
    { 'key': 'productId', 'name': 'Product ID' },
    { 'key': 'description', 'name': 'Description' },
    { 'key': 'quantity', 'name': 'Qty.' },
    { 'key': 'unit', 'name': 'Unit' },
    { 'key': 'unitPrice', 'name': 'Unit Price', 'rightAlign': true },
    { 'key': 'lineAmount', 'name': 'Line Amount', 'rightAlign': true },
    { 'key': 'deliver_quantity', 'name': 'Delivered Qty.' },
    { 'key': 'actions', 'name': 'Actions', 'rightAlign': true }
];

export const invoiceLineHeadView = [
    { 'key': 'id', 'name': 'Select' },
    { 'key': 'lineNo', 'name': 'L. No.' },
    { 'key': 'productId', 'name': 'Product ID' },
    { 'key': 'description', 'name': 'Description' },
    { 'key': 'quantity', 'name': 'Qty.' },
    { 'key': 'unit', 'name': 'Unit' },
    { 'key': 'unitPrice', 'name': 'Unit Price', 'rightAlign': true },
    { 'key': 'discountAmount', 'name': 'Discount Amount', 'rightAlign': true },
    { 'key': 'lineAmount', 'name': 'Line Amount', 'rightAlign': true },
    { 'key': 'available_quantity', 'name': 'Remaining' },
    { 'key': 'invoice_qty', 'name': 'Invoice Qty' },
    { 'key': 'invoice_unitPrice', 'name': 'Invoice Unit Price', 'rightAlign': true },
    { 'key': 'invoice_netAmount', 'name': 'Invoice Net Amount', 'rightAlign': true },
    { 'key': 'gstCode', 'name': 'GST Code' },
    { 'key': 'gstAmount', 'name': 'GST Amount', 'rightAlign': true },
    { 'key': 'actions', 'name': 'Actions', 'rightAlign': true }
];

export const invoiceLineHead = [
    { 'key': 'id', 'name': 'Select' },
    { 'key': 'lineNo', 'name': 'L. No.' },
    { 'key': 'description', 'name': 'Description' },
    { 'key': 'quantity', 'name': 'Qty' },
    { 'key': 'unit', 'name': 'Unit' },
    { 'key': 'unitPrice', 'name': 'Unit Price', 'rightAlign': true },
    { 'key': 'discountAmount', 'name': 'Discount Amount', 'rightAlign': true },
    { 'key': 'lineAmount', 'name': 'Line Amount', 'rightAlign': true },
    { 'key': 'deliver_quantity', 'name': 'Delivered' },
    { 'key': 'available_quantity', 'name': 'Remaining' },
    { 'key': 'invoice_qty', 'name': 'Invoice Qty' },
    { 'key': 'invoice_unitPrice', 'name': 'Invoice Unit Price', 'rightAlign': true },
    { 'key': 'invoice_netAmount', 'name': 'Invoice Net Amount', 'rightAlign': true },
    { 'key': 'gstCode', 'name': 'GST Code' },
    { 'key': 'gstAmount', 'name': 'GST Amount', 'rightAlign': true },
    { 'key': 'actions', 'name': 'Actions', 'rightAlign': true }
];

export const billLineSalesHead = [
    { 'key': 'lineNo', 'name': 'L. No.' },
    { 'key': 'productId', 'name': 'Product Id' },
    { 'key': 'description', 'name': 'Description' },
    { 'key': 'quantity', 'name': 'Qty.' },
    { 'key': 'unit', 'name': 'Unit' },
    { 'key': 'unitPrice', 'name': 'Unit Price', 'rightAlign': true },
    { 'key': 'discountAmount', 'name': 'Discount Amount', 'rightAlign': true },
    { 'key': 'lineAmount', 'name': 'Line Amount', 'rightAlign': true },
    { 'key': 'gstCode', 'name': 'GST Code' },
    { 'key': 'gstAmount', 'name': 'GST Amount', 'rightAlign': true },
    { 'key': 'actions', 'name': 'Actions', 'rightAlign': true }
];

export const productLineHead = [
    { 'key': 'product', 'name': 'Product' },
    { 'key': 'productID', 'name': 'Product ID' },
    { 'key': 'status', 'name': 'Status', 'sorting': true },
    { 'key': 'quantity', 'name': 'Quantity', 'sorting': true },
    { 'key': 'unit', 'name': 'Unit' },
    { 'key': 'amount', 'name': 'Amount', 'rightAlign': true, 'sorting': true },
    { 'key': 'workflow', 'name': 'Workflow', },
    { 'key': 'scheduleFrequency', 'name': 'Frequency' },
    { 'key': 'scheduleFrequency', 'name': 'Frequency Details' },
    { 'key': 'schedule_time', 'name': 'Time' },
    { 'key': 'batch_automate', 'name': 'Batch Automate', 'sorting': true },
    { 'key': 'actions', 'name': 'Actions', 'rightAlign': true }
];

export const customerProductLineHead = [
    { 'key': 'product', 'name': 'Product' },
    { 'key': 'productID', 'name': 'Product ID' },
    { 'key': 'status', 'name': 'Status', 'sorting': true },
    { 'key': 'quantity', 'name': 'Quantity', 'sorting': true },
    { 'key': 'unit', 'name': 'Unit' },
    { 'key': 'actions', 'name': 'Actions', 'rightAlign': true }
];

export const clientsListHead =
    [
        { 'key': 'younoteId', 'name': 'Younote ID' },
        { 'key': 'clientDetails', 'name': 'Client Details' },
        { 'key': 'type', 'name': 'Type' },
        { 'key': 'paid', 'name': 'Paid' }
    ];

export const notificationHead =
    [
        { 'key': 'checkbox', 'name': 'Checkbox' },
        { 'key': 'title', 'name': 'Source' },
        { 'key': 'description', 'name': 'Message' },
        { 'key': 'date', 'name': 'Date / Time' },
        { 'key': 'is_seen', 'name': 'Status' },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "110px" }
    ];

export const allSupplierHead =
    [
        { 'key': 'name', 'name': 'Name', 'sorting': true },
        { 'key': 'serialNo', 'name': 'ID', 'sorting': true },
        { 'key': 'mobile', 'name': 'Ph. Number', 'sorting': true },
        { 'key': 'group', 'name': 'Group' },
        { 'key': 'classification', 'name': 'Classification', 'sorting': true },
        { 'key': 'status', 'name': 'In App Status', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': true }
    ];


export const customerSelfBillHead = [
    { 'key': 'serialNo', 'name': 'SB. Number', 'sorting': true },
    { 'key': 'name', 'name': 'Name', 'sorting': true },
    { 'key': 'customerId', 'name': 'Cust. ID', 'sorting': true },
    { 'key': 'phone', 'name': 'Ph.Number', 'sorting': true },
    { 'key': 'invoiceAmount', 'name': 'Invoice Amount', 'sorting': true, 'rightAlign': true },
    { 'key': 'invoiceDate', 'name': 'Invoice Date', 'sorting': true },
    { 'key': 'dueDate', 'name': 'Due Date', 'sorting': true },
    { 'key': 'createdTs', 'name': 'Created Date' },
    { 'key': 'billStatus', 'name': 'Status', 'sorting': true },
    { 'key': 'action', 'name': 'Actions', 'actionWidth': "110px" }
]

export const salesOrderHead = [
    { 'key': 'serialNo', 'name': 'SO Number', 'sorting': true },
    { 'key': 'customerId', 'name': 'Cust. Name' },
    { 'key': 'customerId', 'name': 'Cust. ID' },
    { 'key': 'phone', 'name': 'Phone Number', 'sorting': true },
    { 'key': 'invoiceAmount', 'name': 'Amount', 'sorting': true, 'rightAlign': true },
    { 'key': 'origin', 'name': 'Order type', 'sorting': true },
    { 'key': 'createTs', 'name': 'Order date', 'sorting': true },
    { 'key': 'deliveryDate', 'name': 'Delivery date', 'sorting': true },
    { 'key': 'hold', 'name': 'On Hold' },
    { 'key': 'OrderStatus', 'name': 'Order Status', 'sorting': true },
    { 'key': 'action', 'name': 'Actions', 'actionWidth': "110px" }
]

export const customerSelfBillLines = [
    { 'key': '', 'name': 'L. No.' },
    { 'key': '', 'name': 'Description' },
    { 'key': '', 'name': 'Qty.' },
    { 'key': '', 'name': 'Unit' },
    { 'key': '', 'name': 'Unit Price' },
    { 'key': '', 'name': 'Discount Amount' },
    { 'key': '', 'name': 'Line Amount' },
    { 'key': '', 'name': 'GST Code' },
    { 'key': '', 'name': 'GST Amount' },
    { 'key': '', 'name': 'Actions', 'actionWidth': '110px' }
]

export const purchaseSelfBillHead = [
    { 'key': 'serialNo', 'name': 'SB. Number', 'sorting': true },
    { 'key': 'name', 'name': 'Name', 'sorting': true },
    { 'key': 'supplierId', 'name': 'Sup. ID' },
    { 'key': 'phone', 'name': 'Ph. Number', 'sorting': true },
    { 'key': 'invoiceAmount', 'name': 'Invoice Amount', 'sorting': true, 'rightAlign': true },
    { 'key': 'invoiceDate', 'name': 'Invoice Date', 'sorting': true },
    { 'key': 'dueDate', 'name': 'Due Date', 'sorting': true },
    { 'key': 'createdTs', 'name': 'Created Date' },
    { 'key': 'billStatus', 'name': 'Status', 'sorting': true },
    { 'key': 'action', 'name': 'Actions', 'actionWidth': true }
]

export const purchaseSelfBillLines = [
    { 'key': 'line', 'name': 'L. No.' },
    { 'key': 'desc', 'name': 'Description' },
    { 'key': 'quantity', 'name': 'Qty.' },
    { 'key': '', 'name': 'Unit' },
    { 'key': '', 'name': 'Unit Price' },
    { 'key': '', 'name': 'Discount Amount' },
    { 'key': '', 'name': 'Line Amount' },
    { 'key': '', 'name': 'GST Code' },
    { 'key': '', 'name': 'GST Amount' },
    { 'key': '', 'name': 'Actions', 'actionWidth': true }
]


export const customerPaymentBillHead =
    [
        { 'key': 'serialNo', 'name': 'Payment ID', 'sorting': true },
        { 'key': 'name', 'name': 'Customer Name' },
        { 'key': 'customerId', 'name': 'Customer ID', 'sorting': true },
        { 'key': 'date', 'name': 'Date', 'sorting': true },
        { 'key': 'paymentAmount', 'name': 'Payment Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'mop', 'name': 'Method Of Payment' },
        { 'key': 'paymentStatus', 'name': 'Payment Status', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "110px" }

    ]

export const salesQuoteHead =
    [
        { 'key': 'serialNo', 'name': 'Quote Number', 'sorting': true },
        { 'key': 'name', 'name': 'Customer Name' },
        { 'key': 'customerId', 'name': 'Customer ID' },
        { 'key': 'phone', 'name': 'Phone Number', 'sorting': true },
        { 'key': 'invoiceAmount', 'name': 'Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'quoteUpdatedDate', 'name': 'Quote Date' },
        { 'key': 'validDate', 'name': 'Valid Till Date', 'sorting': true },
        { 'key': 'QuoteStatus', 'name': 'Status', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': true }
    ]

export const adjustStockHead =
    [
        { 'key': 'serialNo', 'name': 'Transaction Number', 'sorting': true },
        { 'key': 'createTs', 'name': 'Created Date' },
        { 'key': 'updateTs', 'name': 'Updated Date' },
        { 'key': 'createdBy', 'name': 'Created User' },
        { 'key': 'updatedBy', 'name': 'Updated User' },
        { 'key': 'adjustmentStatus', 'name': 'Status', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': true }
    ]

export const customersProductSchedulingHead =
    [
        { 'key': 'customerName', 'name': 'Customer Name' },
        { 'key': 'customerID', 'name': 'Customer ID' },
        { 'key': 'phone', 'name': 'Phone Number', 'sorting': true },
        { 'key': 'email', 'name': 'Email ID', 'sorting': true },
        { 'key': 'scheduleStatus', 'name': 'Status', 'sorting': true },
        { 'key': 'billFormat', 'name': 'Invoice Format', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': true }
    ]

export const purchaseQuoteHead =
    [
        { 'key': 'serialNo', 'name': 'Quote Number', 'sorting': true },
        { 'key': 'name', 'name': 'Supplier Name' },
        { 'key': 'supplierId', 'name': 'Supplier ID' },
        { 'key': 'phone', 'name': 'Phone Number', 'sorting': true },
        { 'key': 'invoiceAmount', 'name': 'Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'quoteUpdatedDate', 'name': 'Quote Date' },
        { 'key': 'validDate', 'name': 'Valid Till Date', 'sorting': true },
        { 'key': 'supply_quote_status', 'name': 'Status', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': true }
    ]

export const purchaseOrderHead =
    [
        { 'key': 'serialNo', 'name': 'PO Number', 'sorting': true },
        { 'key': 'name', 'name': 'Supplier Name' },
        { 'key': 'supplierId', 'name': 'Supplier ID' },
        { 'key': 'phone', 'name': 'Phone Number', 'sorting': true },
        { 'key': 'invoiceAmount', 'name': 'Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'createTs', 'name': 'Order Date', 'sorting': true, },
        { 'key': 'deliveryDate', 'name': 'Delivery date', 'sorting': true },
        { 'key': 'isHols', 'name': 'On Hold' },
        { 'key': 'OrderStatus', 'name': 'Status', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': true }
    ]

export const supplierPaymentBillHead =
    [
        { 'key': 'serialNo', 'name': 'Payment ID', 'sorting': true },
        { 'key': 'name', 'name': 'Sup. Name' },
        { 'key': 'supplierId', 'name': 'Sup. ID' },
        { 'key': 'date', 'name': 'Date', 'sorting': true },
        { 'key': 'paymentAmount', 'name': 'Payment Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'mop', 'name': 'Method Of Payment' },
        { 'key': 'paymentStatus', 'name': 'Payment Status', 'sorting': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': true }
    ]


export const gabHead =
    [
        { 'key': 'checkbox', 'name': 'Checkbox' },
        { 'key': 'contactName', 'name': 'Name', 'sorting': true },
        { 'key': 'id', 'name': 'GAB ID', 'sorting': true },
        { 'key': 'businessId', 'name': 'Younote ID', 'sorting': true },
        { 'key': 'mobile', 'name': 'Ph. Number', 'sorting': true },
        { 'key': 'address1', 'name': 'Address', 'sorting': true },
        { 'key': 'isPrimary', 'name': 'Primary', 'sorting': true },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const gabLinkedAccountsHead =
    [
        { 'key': 'gabId', 'name': 'GAB Id' },
        { 'key': 'id', 'name': 'YOU Id' },
        { 'key': 'name', 'name': 'Name/ Business Name' },
        { 'key': 'userType', 'name': 'User Type', 'rightAlign': true }
    ];

export const gsttransactionsHead =
    [
        { 'key': 'transactionReference', 'name': 'Trans. Ref.' },
        { 'key': 'supplierRefNum', 'name': 'Sup. Inv. Num.' },
        { 'key': 'name', 'name': 'Party Name' },
        { 'key': 'invoiceNumber', 'name': 'Invoice Ref. Num.' },
        { 'key': 'date', 'name': 'Trans. Date', 'sorting': true },
        { 'key': 'type', 'name': 'Source', 'sorting': true },
        { 'key': 'originAmount', 'name': 'Origin Amnt.', 'sorting': true, 'rightAlign': true, 'amount': true, 'helpText': "Total Net amount of the Invoice" },
        { 'key': 'gst', 'name': 'Party GST Code' },
        { 'key': 'netTaxRate', 'name': 'Net Rate', 'sorting': true },
        { 'key': 'adjustedValue', 'name': 'Adj. GST', 'sorting': true, 'rightAlign': true },
        { 'key': 'calculatedValue', 'name': 'GST Amnt.', 'sorting': true, 'rightAlign': true },
        { 'key': 'invoiceAmount', 'name': 'Invoice Amnt.', 'rightAlign': true, 'amount': true },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const taxtransactionsHead =
    [
        { 'key': 'transactionReference', 'name': 'Trans. Ref.' },
        { 'key': 'supplierRefNum', 'name': 'Sup. Inv. Num.' },
        { 'key': 'name', 'name': 'Party Name' },
        { 'key': 'pan', 'name': 'Party PAN' },
        { 'key': 'invoiceNumber', 'name': 'Invoice Ref. Num.' },
        { 'key': 'date', 'name': 'Trans. Date', 'sorting': true },
        { 'key': 'invoiceDate', 'name': 'Invoice Date', 'sorting': true },
        { 'key': 'type', 'name': 'Source', 'sorting': true },
        { 'key': 'originAmount', 'name': 'Origin Amnt.', 'sorting': true, 'rightAlign': true, 'amount': true, 'helpText': "Total Net amount of the Invoice" },
        { 'key': 'gst', 'name': 'Party GST Code' },
        { 'key': 'netTaxRate', 'name': 'Net Rate', 'sorting': true },
        { 'key': 'adjustedValue', 'name': 'Adj. GST', 'sorting': true, 'rightAlign': true },
        { 'key': 'calculatedValue', 'name': 'GST Amnt.', 'sorting': true, 'rightAlign': true },
        { 'key': 'cashDiscountAmount', 'name': 'Cash Discount Amount', 'sorting': true },
        { 'key': 'exciseAmount', 'name': 'Excise Amount', 'sorting': true },
        { 'key': 'tax', 'name': 'Tax', 'sorting': true, 'rightAlign': true },
        { 'key': 'tcs', 'name': 'TCS', 'sorting': true, 'rightAlign': true },
        { 'key': 'invoiceAmount', 'name': 'Invoice Amnt.', 'rightAlign': true, 'amount': true },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const gstrHsnTransactionsHead =
    [
        { 'key': 'transactionReference', 'name': 'Trans. Ref.' },
        { 'key': 'supplierRefNum', 'name': 'Sup. Inv. Num.' },
        { 'key': 'name', 'name': 'Party Name' },
        { 'key': 'gstIn', 'name': 'GSTIN' },
        { 'key': 'placeOfSupply', 'name': 'Place Of Supply' },
        { 'key': 'invoiceNumber', 'name': 'Invoice Ref. Num.' },
        { 'key': 'date', 'name': 'Trans. Date' },
        { 'key': 'type', 'name': 'Source' },
        { 'key': 'originAmount', 'name': 'Origin Amnt.', 'rightAlign': true, 'amount': true, 'helpText': "Total Net amount of the Invoice" },
        { 'key': 'invoiceAmount', 'name': 'Invoice Amnt.', 'rightAlign': true, 'amount': true },
        { 'key': 'product', 'name': 'Pro. Name' },
        { 'key': 'product', 'name': 'Pro. Id' },
        { 'key': 'unit', 'name': 'Unit' },
        { 'key': 'quantity', 'name': 'Qty' },
        { 'key': 'amount', 'name': 'Line Amount', 'rightAlign': true },
        { 'key': 'disAmount', 'name': 'Discount', 'rightAlign': true },
        { 'key': 'productgst', 'name': 'Product GST' },
        { 'key': 'gst', 'name': 'GST Amount', 'rightAlign': true },
        { 'key': 'hsn', 'name': 'HSN Code' },
        { 'key': 'sgst', 'name': 'SGST / UTGST', 'rightAlign': true },
        { 'key': 'cgst', 'name': 'CGST', 'rightAlign': true },
        { 'key': 'igst', 'name': 'IGST', 'rightAlign': true },
    ];

export const gstrSummaryTransactionsHead =
    [
        { 'key': 'txnInvoiceNumber', 'name': 'Invoice Number' },
        { 'key': 'date', 'name': 'Invoice Date' },
        { 'key': 'invoiceAmount', 'name': 'Invoice Amount' },
        { 'key': 'partyName', 'name': 'Party Name' },
        { 'key': 'gstIn', 'name': 'GSTIN Number' },
        { 'key': 'placeOfSupply', 'name': 'Place Of Supply' },
        { 'key': 'type', 'name': 'Source' },
        { 'key': 'productGstCode', 'name': 'Product GST Code' },
        { 'key': 'taxableAmount', 'name': 'Taxable amount' },
        { 'key': 'quantity', 'name': 'Qty' },
        { 'key': 'sgstPercentage', 'name': 'SGST Percentage' },
        { 'key': 'sgst', 'name': 'Sum of SGST Amount' },
        { 'key': 'cgstPercentage', 'name': 'CGST Percentage' },
        { 'key': 'cgst', 'name': 'Sum of CGST Amount' },
        { 'key': 'igstPercentage', 'name': 'IGST Percentage' },
        { 'key': 'igst', 'name': 'Sum of IGST Amount' },
        { 'key': 'amount', 'name': 'Sum of Line Amout' },
    ];

export const gstrHsnSummaryTransactionsHead =
    [
        { 'key': 'txnInvoiceNumber', 'name': 'Invoice Number' },
        { 'key': 'date', 'name': 'Invoice Date' },
        { 'key': 'invoiceAmount', 'name': 'Invoice Amount' },
        { 'key': 'partyName', 'name': 'Party Name' },
        { 'key': 'gstIn', 'name': 'GSTIN Number' },
        { 'key': 'placeOfSupply', 'name': 'Place Of Supply' },
        { 'key': 'type', 'name': 'Source' },
        { 'key': 'productGstCode', 'name': 'Product GST Code' },
        { 'key': 'productGstCode', 'name': 'HSN Code' },
        { 'key': 'taxableAmount', 'name': 'Taxable amount' },
        { 'key': 'quantity', 'name': 'Qty' },
        { 'key': 'sgstPercentage', 'name': 'SGST Percentage' },
        { 'key': 'sgst', 'name': 'Sum of SGST Amount' },
        { 'key': 'cgstPercentage', 'name': 'CGST Percentage' },
        { 'key': 'cgst', 'name': 'Sum of CGST Amount' },
        { 'key': 'igstPercentage', 'name': 'IGST Percentage' },
        { 'key': 'igst', 'name': 'Sum of IGST Amount' },
        { 'key': 'amount', 'name': 'Sum of Line Amout' },
    ];

export const GSTTransactionLines =
    [
        { 'key': 'lineno', 'name': 'L.No.' },
        { 'key': 'desc', 'name': 'Description' },
        { 'key': 'product', 'name': 'Product Id' },
        { 'key': 'netamot', 'name': 'Net Amount', 'rightAlign': true },
        { 'key': 'gst', 'name': 'GST Amount', 'rightAlign': true },
        { 'key': 'productgst', 'name': 'Product GST' },
        { 'key': 'sgst', 'name': 'SGST / UTGST' },
        { 'key': 'cgst', 'name': 'CGST' },
        { 'key': 'igst', 'name': 'IGST', 'rightAlign': true },
    ];

export const TAXTransactionLines =
    [
        { 'key': 'lineno', 'name': 'L.No.' },
        { 'key': 'desc', 'name': 'Description' },
        { 'key': 'product', 'name': 'Product Id' },
        { 'key': 'unit', 'name': 'Unit' },
        { 'key': 'quantity', 'name': 'Quantity' },
        { 'key': 'netamot', 'name': 'Net Amount', 'rightAlign': true },
        { 'key': 'gst', 'name': 'GST Amount', 'rightAlign': true },
        { 'key': 'excisesTotal', 'name': 'Excise Total', 'rightAlign': true },
        { 'key': 'productgst', 'name': 'Product GST' },
        { 'key': 'sgst', 'name': 'SGST / UTGST' },
        { 'key': 'cgst', 'name': 'CGST' },
        { 'key': 'igst', 'name': 'IGST', 'rightAlign': true },
    ];

export const activityPrefixManagementHead =
    [
        { 'key': 'module', 'name': 'Module' },
        { 'key': 'featureId', 'name': 'Feature', 'sorting': true },
        { 'key': 'prefix', 'name': 'Prefix', 'sorting': true },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const activityPrefixCounterHead =
    [
        { 'key': 'module', 'name': 'Module' },
        { 'key': 'featureId', 'name': 'Feature' },
        { 'key': 'number', 'name': 'Starting Number' },
        { 'key': 'number', 'name': 'Next Number' },
        { 'key': 'number', 'name': 'Business No. Sequence' },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const globalActivityPrefixCounterHead =
    [
        { 'key': 'module', 'name': 'Module' },
        { 'key': 'featureId', 'name': 'Feature' },
        { 'key': 'number', 'name': 'Counter Number' },
        { 'key': 'action', 'name': 'Actions' }
    ];

export const customerTransactionsHead =
    [
        { 'key': 'taxInvoice', 'name': 'Invoice Number' },
        { 'key': 'paymentReference', 'name': 'Payment ID' },
        { 'key': 'name', 'name': 'Customer Name', },
        { 'key': 'customerId', 'name': 'Customer ID' },
        { 'key': 'date', 'name': 'Date', 'sorting': true },
        { 'key': 'type', 'name': 'Trans. Type', 'sorting': true },
        { 'key': 'documentDate', 'name': 'Document Date' },
        { 'key': 'amount', 'name': 'Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'balance', 'name': 'Balance', 'sorting': true, 'rightAlign': true },
        { 'key': 'mop', 'name': 'MOP' },
        { 'key': 'action', 'name': '' },
    ]

export const supplierTransactionsHead =
    [
        { 'key': 'taxInvoice', 'name': 'Invoice Number' },
        { 'key': 'paymentReference', 'name': 'Payment ID' },
        { 'key': 'name', 'name': 'Sup. Name' },
        { 'key': 'supplierId', 'name': 'Supplier ID', 'sorting': true },
        { 'key': 'date', 'name': 'Date', 'sorting': true },
        { 'key': 'type', 'name': 'Trans. Type', 'sorting': true },
        { 'key': 'documentDate', 'name': 'Document Date' },
        { 'key': 'amount', 'name': 'Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'balance', 'name': 'Balance', 'sorting': true, 'rightAlign': true },
        { 'key': 'mop', 'name': 'MOP' },
        { 'key': 'action', 'name': '' },
    ]

export const InvoiceHistory =
    [
        { 'key': 'checkbox', 'name': 'Checkbox' },
        { 'key': 'serialNo', 'name': 'Invoice Number', 'sorting': true },
        { 'key': 'invoiceDate', 'name': 'Invoice Date', 'sorting': true },
        { 'key': 'dueDate', 'name': 'Due Date', 'sorting': true },
        { 'key': 'createTs', 'name': 'Created Date' },
        { 'key': 'customerName', 'name': 'Cus. Name', 'sorting': true },
        { 'key': 'customerId', 'name': 'Cus. ID', 'sorting': true },
        // { 'key': 'selfBillId', 'name': 'Reference', 'sorting': true },
        { 'key': 'invoiceAmount', 'name': 'Invoice Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'balanceAmount', 'name': 'Balance Amount', 'rightAlign': true },
        { 'key': 'actions', 'name': 'Actions' },

    ]

export const DeliveryNoteHistory =
    [
        { 'key': 'serialNo', 'name': 'Delivery Number', 'sorting': true },
        { 'key': 'customer_name', 'name': 'Cus. Name', 'sorting': true },
        { 'key': 'customer_email', 'name': 'Cus. Email', 'sorting': true },
        { 'key': 'customer_phone', 'name': 'Cus. Phone', 'sorting': true },
        { 'key': 'deliveryDate', 'name': 'Date', 'sorting': true },
        { 'key': 'deliveryStatus', 'name': 'Status', 'sorting': true },
        { 'key': 'actions', 'name': 'Actions' },

    ]

export const PurchaseGoodsHistory =
    [
        { 'key': 'serialNo', 'name': 'Delivery Number', 'sorting': true },
        { 'key': 'supplier_name', 'name': 'Sup. Name', 'sorting': true },
        { 'key': 'supplier_email', 'name': 'Sup. Email', 'sorting': true },
        { 'key': 'supplier_phone', 'name': 'Sup. Phone', 'sorting': true },
        { 'key': 'deliveryDate', 'name': 'Date', 'sorting': true },
        { 'key': 'deliveryStatus', 'name': 'Status', 'sorting': true },
        { 'key': 'actions', 'name': 'Actions' },

    ]

export const verifySalesPrice =
    [
        { 'key': 'checkbox', 'name': 'Checkbox' },
        { 'key': 'productName', 'name': 'Product Name' },
        { 'key': 'salesPrice', 'name': 'Sales Price', 'rightAlign': true },
        { 'key': 'mrp', 'name': 'MRP', 'rightAlign': true }

    ]

export const verifyPurchasePrice =
    [
        { 'key': 'productName', 'name': 'Product Name' },
        { 'key': 'supplierName', 'name': 'Supplier Name' },
        { 'key': 'purchasePrice', 'name': 'Purchase Price', 'rightAlign': true }
    ]


export const SalesPriceHead =
    [
        { 'key': 'salesPriceId', 'name': 'Price ID', 'sorting': true },
        { 'key': 'customerSpec', 'name': 'Cus. Spec.', 'sorting': true },
        { 'key': 'productName', 'name': 'Product Name' },
        { 'key': 'productId', 'name': 'Product ID' },
        { 'key': 'fromDate', 'name': 'From Date', 'sorting': true },
        { 'key': 'toDate', 'name': 'To Date', 'sorting': true },
        // { 'key': 'id', 'name': 'Qty', 'sorting': true },
        { 'key': 'unitId', 'name': 'Unit' },
        { 'key': 'margin', 'name': 'Margin', 'sorting': true },
        { 'key': 'productCode', 'name': 'Product Code' },
        { 'key': 'price', 'name': 'Sales Price', 'sorting': true, 'rightAlign': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "90px" },
    ]

export const SalesDiscountHead =
    [
        { 'key': 'priceId', 'name': 'Price ID', 'sorting': true },
        { 'key': 'customerSpec', 'name': 'Cus. Spec.', 'sorting': true },
        { 'key': 'productName', 'name': 'Product Name' },
        { 'key': 'productId', 'name': 'Product ID' },
        { 'key': 'productCode', 'name': 'Product Code' },
        { 'key': 'productGroupId', 'name': 'Pro. Group Name' },
        { 'key': 'fromDate', 'name': 'From Date', 'sorting': true },
        { 'key': 'toDate', 'name': 'To Date', 'sorting': true },
        { 'key': 'unitId', 'name': 'Unit' },
        { 'key': 'discountPercent', 'name': 'Percentage', 'sorting': true, 'rightAlign': true },
        { 'key': 'discountAmount', 'name': 'Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "90px" },
    ]

export const QuantityDiscountHead =
    [
        { 'key': 'priceId', 'name': 'Price ID', 'sorting': true },
        { 'key': 'customerSpec', 'name': 'Cus. Spec.', 'sorting': true },
        { 'key': 'quantitySpec', 'name': 'Qut. Spec.', 'sorting': true },
        { 'key': 'productName', 'name': 'Product Name' },
        { 'key': 'productId', 'name': 'Product ID' },
        { 'key': 'productCode', 'name': 'Product Code' },
        { 'key': 'fromDate', 'name': 'From Date', 'sorting': true },
        { 'key': 'toDate', 'name': 'To Date', 'sorting': true },
        { 'key': 'salesUnitId', 'name': 'Unit' },
        { 'key': 'salesQty', 'name': 'Quantity', 'sorting': true },
        { 'key': 'productName', 'name': 'Free Product Name' },
        { 'key': 'freeQty', 'name': 'Free Quantity', 'sorting': true },
        { 'key': 'freeUnitId', 'name': 'Free Unit' },
        { 'key': 'action', 'name': 'Actions', 'actionWidth': "90px" },
    ]


export const StoreSalesHead =
    [
        { 'key': 'id', 'name': 'Cash Receipt No.', 'sorting': true },
        { 'key': 'customerName', 'name': 'Name' },
        { 'key': 'customerMobile', 'name': 'Phone Number' },
        { 'key': 'customerEmail', 'name': 'Email Id' },
        { 'key': 'transactionDate', 'name': 'Transaction Date', 'sorting': true },
        { 'key': 'invoiceAmount', 'name': 'Invoice Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'userName', 'name': 'User Name' },
        { 'key': 'posName', 'name': 'POS' },
        { 'key': 'status', 'name': 'Status' },
        { 'key': 'type', 'name': 'Type' },
        { 'key': 'action', 'name': 'Actions' },
    ]

export const StoreSalesLine =
    [
        { 'key': 'id', 'name': 'L. No.' },
        { 'key': 'description', 'name': 'Description' },
        { 'key': 'quantity', 'name': 'Quantity', 'centerAlign': true },
        { 'key': 'unit', 'name': 'Unit', 'centerAlign': true },
        { 'key': 'unitPrice', 'name': 'Unit Price', 'rightAlign': true },
        { 'key': 'amount', 'name': 'Line Amnt.', 'rightAlign': true },
        { 'key': '', 'name': '', 'actionWidth': "20px" },
    ]

export const PriceListHeadSorting =
    [
        { 'key': 'checkbox', 'name': 'Checkbox' },
        { 'key': 'productName', 'name': 'Product Name' },
        { 'key': 'universalProductId', 'name': 'Universal Product ID' },
        { 'key': 'productId', 'name': 'Product ID' },
        { 'key': 'fromDate', 'name': 'From Date', 'sorting': true },
        { 'key': 'toDate', 'name': 'To Date', 'sorting': true },
        { 'key': 'unitId', 'name': 'Unit' },
        { 'key': 'price', 'name': 'Sales Price', 'sorting': true, 'rightAlign': true },
        { 'key': 'maxRetailPrice', 'name': 'MRP', 'sorting': true, 'rightAlign': true },
        { 'key': 'updateTs', 'name': 'Updated Date', 'sorting': true, 'leftAlign': true }
    ]

export const PriceListHead =
    [
        { 'key': 'checkbox', 'name': 'Checkbox' },
        { 'key': 'productName', 'name': 'Product Name' },
        { 'key': 'universalProductId', 'name': 'Universal Product ID' },
        { 'key': 'productId', 'name': 'Product ID' },
        { 'key': 'fromDate', 'name': 'From Date' },
        { 'key': 'toDate', 'name': 'To Date' },
        { 'key': 'unitId', 'name': 'Unit' },
        { 'key': 'price', 'name': 'Sales Price', 'rightAlign': true },
        { 'key': 'maxRetailPrice', 'name': 'MRP', 'rightAlign': true },
        { 'key': 'updateTs', 'name': 'Updated Date', 'leftAlign': true }
    ]

export const PriceListInBoundHead =
    [
        { 'key': 'productName', 'name': 'Product Name' },
        { 'key': 'universalProductId', 'name': 'Universal Product ID' },
        { 'key': 'productId', 'name': 'Product ID' },
        { 'key': 'productId', 'name': 'Sup. Product ID' },
        { 'key': 'fromDate', 'name': 'From Date' },
        { 'key': 'toDate', 'name': 'To Date' },
        { 'key': 'unitId', 'name': 'Unit' },
        { 'key': 'price', 'name': 'Sales Price', 'rightAlign': true },
        { 'key': 'maxRetailPrice', 'name': 'MRP', 'rightAlign': true },
        { 'key': 'validated', 'name': 'Validated' },
        { 'key': 'priceUpdated', 'name': 'Price Updated' }
    ]

export const QueryListHead =
    [
        { 'key': 'checkbox', 'name': 'Checkbox' },
        { 'key': 'customerName', 'name': 'Customer Name' },
        { 'key': 'productId', 'name': 'Product' },
        { 'key': 'productId', 'name': 'Product ID' },
        { 'key': 'workflowId', 'name': 'Work Flow' },
        { 'key': 'status', 'name': 'Status' },
        { 'key': 'dateOfSchedule', 'name': 'Date of Schedule' },
        { 'key': 'quantity', 'name': 'Qty' },
        { 'key': 'unitId', 'name': 'Unit' },
        { 'key': 'amount', 'name': 'Amount', 'rightAlign': true },
        { 'key': 'maxRetailPrice', 'name': 'Frequency' },
        { 'key': 'FreqDetail', 'name': 'Freq.Detail' },
    ]

export const PriceCustomerListHead =
    [
        { 'key': 'checkbox', 'name': 'Checkbox' },
        { 'key': 'customerName', 'name': 'Customer Name' },
        { 'key': 'serialNo', 'name': 'Customer ID' },
        { 'key': 'mobile', 'name': 'Phone Number' },
        { 'key': 'customerBusinessId', 'name': 'Younote ID' },
        { 'key': 'inAppStatus', 'name': 'In App Status', 'leftAlign': true },
    ]


export const PriceCustomerListHeadSorting =
    [
        { 'key': 'checkbox', 'name': 'Checkbox' },
        { 'key': 'customerName', 'name': 'Customer Name' },
        { 'key': 'serialNo', 'name': 'Customer ID', 'sorting': true },
        { 'key': 'mobile', 'name': 'Phone Number', 'sorting': true },
        { 'key': 'customerBusinessId', 'name': 'Younote ID', 'sorting': true },
        { 'key': 'inAppStatus', 'name': 'In App Status', 'sorting': true, 'leftAlign': true },
    ]




export const SalesPriceHeadCustomer =
    [
        { 'key': 'id', 'name': 'Price ID', 'sorting': true },
        { 'key': 'customerSpec', 'name': 'Cus. Spec.', 'sorting': true },
        { 'key': 'productName', 'name': 'Product Name' },
        { 'key': 'productId', 'name': 'Product ID' },
        { 'key': 'fromDate', 'name': 'From Date', 'sorting': true },
        { 'key': 'toDate', 'name': 'To Date', 'sorting': true },
        // { 'key': 'id', 'name': 'Qty', 'sorting': true },
        { 'key': 'unitId', 'name': 'Unit' },
        { 'key': 'margin', 'name': 'Margin', 'sorting': true },
        { 'key': 'price', 'name': 'Sales Price', 'sorting': true, 'rightAlign': true },
        { 'key': 'action', 'name': 'Actions', 'rightAlign': true },

    ]

export const SalesDiscountHeadCustomer =
    [
        { 'key': 'priceId', 'name': 'Price ID', 'sorting': true },
        { 'key': 'customerSpec', 'name': 'Cus. Spec.', 'sorting': true },
        { 'key': 'productName', 'name': 'Product Name' },
        { 'key': 'productId', 'name': 'Product ID' },
        { 'key': 'productGroupId', 'name': 'Pro. Group Name' },
        { 'key': 'fromDate', 'name': 'From Date', 'sorting': true },
        { 'key': 'toDate', 'name': 'To Date', 'sorting': true },
        { 'key': 'unitId', 'name': 'Unit' },
        { 'key': 'discountPercent', 'name': 'Percentage', 'sorting': true, 'rightAlign': true },
        { 'key': 'discountAmount', 'name': 'Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'action', 'name': 'Actions', 'rightAlign': true },

    ]

export const PurchasePriceHead =
    [
        { 'key': 'purchasePriceId', 'name': 'Price ID', 'sorting': true },
        { 'key': 'supplierName', 'name': 'Supplier Name' },
        { 'key': 'productName', 'name': 'Product Name' },
        { 'key': 'productId', 'name': 'Product ID' },
        { 'key': 'fromDate', 'name': 'From Date', 'sorting': true },
        { 'key': 'toDate', 'name': 'To Date', 'sorting': true },
        { 'key': 'unitId', 'name': 'Unit', 'sorting': true },
        { 'key': 'productCode', 'name': 'Product Code' },
        { 'key': 'price', 'name': 'Purchase Price', 'sorting': true, 'rightAlign': true },
        { 'key': 'actions', 'name': 'Actions' }
    ]

export const purchaseInvoiceHistory =
    [
        { 'key': 'checkbox', 'name': 'Checkbox' },
        { 'key': 'serialNo', 'name': 'Invoice Number', 'sorting': true },
        { 'key': 'supplierRefNum', 'name': 'Ref Number', 'sorting': true },
        { 'key': 'invoiceDate', 'name': 'Invoice Date', 'sorting': true },
        { 'key': 'dueDate', 'name': 'Due Date', 'sorting': true },
        { 'key': 'createdTs', 'name': 'Created Date' },
        { 'key': 'supplierName', 'name': 'Sup. Name', 'sorting': true },
        { 'key': 'supplierId', 'name': 'Sup. ID' },
        // { 'key': 'selfBillId', 'name': 'Reference', 'sorting': true },
        { 'key': 'invoiceAmount', 'name': 'Invoice Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'balanceAmount', 'name': 'Balance Amount', 'rightAlign': true },
        { 'key': 'actions', 'name': 'Actions' },

    ]

export const openInvoicesHead =
    [
        { 'key': 'checkbox', 'name': '' },
        { 'key': 'taxInvoice', 'name': 'Ref. No.' },
        { 'key': 'documentDate', 'name': 'Doc. Date' },
        { 'key': 'amount', 'name': 'Invoice Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'date', 'name': 'Date', 'sorting': true },
        { 'key': 'balance', 'name': 'Balance', 'sorting': true, 'rightAlign': true },
        { 'key': 'settlementAmount', 'name': 'Amount to Settle' },
    ]

export const featurePermisionHead =
    [
        { 'key': 'checkbox', 'name': 'Checkbox' },
        { 'key': 'feature', 'name': 'Feature', 'actionWidth': '150px' },
        { 'key': 'module', 'name': 'Module', 'actionWidth': '150px' },
        { 'key': 'create', 'name': 'Create' },
        { 'key': 'view', 'name': 'View' },
        { 'key': 'edit', 'name': 'Edit' },
        { 'key': 'delete', 'name': 'Delete', 'leftAlign': true },
    ]

export const componentPermisionHead =
    [
        { 'key': '', 'name': 'Feature', 'actionWidth': '150px' },
        { 'key': '', 'name': 'Module', 'actionWidth': '150px' },
        { 'key': '', 'name': 'Component' },
        { 'key': '', 'name': 'Component Type' },
        { 'key': '', 'name': 'Enabled' },
        { 'key': '', 'name': 'Actions' },
    ]

export const featureComponentHead =
    [
        { 'key': '', 'name': 'Feature', 'actionWidth': '150px' },
        { 'key': '', 'name': 'Component' },
        { 'key': '', 'name': 'Component Type' },
        { 'key': '', 'name': 'Actions' },
    ]

export const clientTaggingHead =
    [
        { 'key': '', 'name': 'Client' },
        { 'key': '', 'name': 'Client ID' },
        { 'key': '', 'name': 'Actions' }
    ]

export const purOpenInvoicesHead =
    [
        { 'key': '', 'name': '' },
        { 'key': 'taxInvoice', 'name': 'Ref. Number', 'sorting': true },
        { 'key': 'amount', 'name': 'Invoice Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'Date', 'name': 'Date', 'sorting': true },
        { 'key': 'balance', 'name': 'Balance Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'settlementAmount', 'name': 'Amount to Settle' },
    ]

export const openCreditsHead =
    [
        { 'key': 'checkbox', 'name': '' },
        { 'key': 'paymentReference', 'name': 'Ref. No.' },
        { 'key': 'documentDate', 'name': 'Doc. Date' },
        { 'key': 'amount', 'name': 'Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'date', 'name': 'Date', 'sorting': true },
        { 'key': 'balance', 'name': 'Balance', 'sorting': true, 'rightAlign': true },
        // { 'key': 'description', 'name': 'Payment Reference' },
    ]

export const purOpenCreditsHead =
    [
        { 'key': '', 'name': '' },
        { 'key': 'paymentReference', 'name': 'Ref. Number', 'sorting': true, },
        { 'key': 'amount', 'name': 'Invoice Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'date', 'name': 'Date', 'sorting': true },
        { 'key': 'balance', 'name': 'Balance Amount', 'sorting': true, 'rightAlign': true },
        // { 'key': 'description', 'name': 'Payment Reference' },
    ]

export const settledInvoicesHead =
    [
        { 'key': 'checkbox', 'name': '' },
        { 'key': 'taxInvoice', 'name': 'Ref. No.' },
        { 'key': 'documentDate', 'name': 'Doc. Date' },
        { 'key': 'amount', 'name': 'Invoice Amount', 'rightAlign': true },
        { 'key': 'date', 'name': 'Settle Date' },
        { 'key': 'amount', 'name': 'Settled Amount', 'rightAlign': true },
    ];

export const purSettledInvoicesHead =
    [
        { 'key': '', 'name': '' },
        { 'key': 'taxInvoice', 'name': 'Ref. Number', 'sorting': true, },
        { 'key': 'amount', 'name': 'Invoice Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'documentDate', 'name': 'Date', 'sorting': true },
        { 'key': 'date', 'name': 'Balance Amount', 'sorting': true },
        { 'key': 'amount', 'name': 'Settled Amount', 'sorting': true },
    ];

export const settledCreditsHead =
    [
        { 'key': 'checkbox', 'name': '' },
        { 'key': 'paymentSerialNo', 'name': 'Ref. No.' },
        { 'key': 'documentDate', 'name': 'Doc. Date' },
        { 'key': 'amount', 'name': 'Amount', 'rightAlign': true },
        { 'key': 'date', 'name': 'Settled Date' },
        { 'key': 'settledAmount', 'name': 'Settled Amount', 'rightAlign': true },
        // { 'key': 'description', 'name': 'Payment Reference', 'sorting': true },
    ];

export const purSettledCreditsHead =
    [
        { 'key': '', 'name': '' },
        { 'key': 'paymentReference', 'name': 'Ref. Number', 'sorting': true },
        { 'key': 'amount', 'name': 'Amount', 'sorting': true, 'rightAlign': true },
        { 'key': 'date', 'name': 'Settled Date', 'sorting': true },
        { 'key': 'amount', 'name': 'Balance Amount', 'sorting': true },
        // { 'key': 'description', 'name': 'Payment Reference', 'sorting': true },
    ];

export const selectInvoiceHead =
    [
        { 'key': '', 'name': '' },
        { 'key': '', 'name': 'Invoice number' },
        { 'key': '', 'name': 'Invoice Date' },
        { 'key': '', 'name': 'Amount due', 'rightAlign': true },
        { 'key': '', 'name': 'Amount to Settle', 'rightAlign': true },
        { 'key': '', 'name': 'Balance', 'rightAlign': true },
        { 'key': '', 'name': 'Status', 'actionWidth': '75px', 'rightAlign': true },
    ];

export const selectPurchaseInvoiceHead =
    [
        { 'key': '', 'name': '' },
        { 'key': '', 'name': 'Internal Invoice number' },
        { 'key': '', 'name': 'Supplier Invoice number' },
        { 'key': '', 'name': 'Invoice Date' },
        { 'key': '', 'name': 'Amount due', 'rightAlign': true },
        { 'key': '', 'name': 'Amount to Settle', 'rightAlign': true },
        { 'key': '', 'name': 'Balance', 'rightAlign': true },
        { 'key': '', 'name': 'Status', 'actionWidth': '75px', 'rightAlign': true },
    ];

export const priceList = [
    [10, 20, 50, 100, 200, 500, 1000, 2000]
];

export const selectInvoiceViewHead =
    [
        { 'key': '', 'name': 'Invoice Number' },
        { 'key': '', 'name': 'Invoice Date' },
        { 'key': '', 'name': 'Amount', 'rightAlign': true },
        { 'key': '', 'name': 'Settled Amount', 'rightAlign': true }
    ];

export const selectPurchaseInvoiceViewHead =
    [
        { 'key': '', 'name': 'Internal Invoice number' },
        { 'key': '', 'name': 'Supplier Invoice number' },
        { 'key': '', 'name': 'Invoice Date' },
        { 'key': '', 'name': 'Amount', 'rightAlign': true },
        { 'key': '', 'name': 'Settled Amount', 'rightAlign': true }
    ];

export const confirmedselectPurchaseInvoiceViewHead =
    [
        { 'key': '', 'name': 'Internal Invoice number' },
        { 'key': '', 'name': 'Supplier Invoice number' },
        { 'key': '', 'name': 'Invoice Date' },
        { 'key': '', 'name': 'Amount due', 'rightAlign': true },
        { 'key': '', 'name': 'Amount to settle', 'rightAlign': true }
    ];

export const confirmedselectInvoiceViewHead =
    [
        { 'key': '', 'name': 'Invoice Number' },
        { 'key': '', 'name': 'Invoice Date' },
        { 'key': '', 'name': 'Amount due', 'rightAlign': true },
        { 'key': '', 'name': 'Amount to settle', 'rightAlign': true }
    ];


export const purchaseSelectInvoiceHead =
    [
        { 'key': '', 'name': '' },
        { 'key': '', 'name': 'Invoice Number' },
        { 'key': '', 'name': 'Invoice Date' },
        { 'key': '', 'name': 'Amount' },
        { 'key': '', 'name': 'Amount to Settle' },
        { 'key': '', 'name': 'Balance' },
        { 'key': '', 'name': 'Status', 'actionWidth': '110px' },
    ]

export const countryList = ['Country', 'India']
export const stateList = ['State', 'Delhi']

export const addressHead = ['Name', 'Long Name', 'Currency Name', 'Currency Symbol', 'Actions'];


export const LinkProductsHead =
    [
        { 'key': 'checkbox', 'name': 'Checkbox' },
        { 'key': '', 'name': 'Product ID' },
        { 'key': '', 'name': 'Product Name' },
    ]

export const LinkProductsListHead =
    [
        { 'key': '', 'name': 'Product ID' },
        { 'key': '', 'name': 'Product Name' },
        { 'key': '', 'name': 'Product Type' },
        { 'key': '', 'name': 'SKU Quantity' },
        { 'key': '', 'name': 'Unit' },
        { 'key': '', 'name': 'HSN Code' },
        { 'key': '', 'name': 'Product GST' }
    ];

export const templateType = [
    { id: 'format1', label: 'BTST' },
    // { id: 'format2', label: 'Format 2' },
    // { id: 'format3', label: 'Format 3' },
    // { id: 'format4', label: 'Format 4' },
    //                      { id: 'format5', label: 'Format 2' },
    // { id: 'format6', label: 'Format 6' },
    //                        { id: 'format7', label: 'Format 3' },
    // { id: 'format8', label: 'Format 8' },
    //                         { id: 'format9', label: 'Format 4' },
    //  { id: 'format10', label: 'Format10' },
    { id: 'btst-1', label: 'BTST-1' },
    { id: 'letter', label: 'Letter Head' },
    { id: 'billSupply', label: 'Bill of Supply' },
    { id: 'SBP', label: 'SB-P' },
    { id: 'SBL', label: 'SB-L' },
    { id: 'EX01', label: 'EX-01' }
];

export const quoteTemplateType = [
    { id: 'quote-GST', label: 'GST - Template' },
    { id: 'quote-no_GST', label: 'No GST - Template' },
    { id: 'EX01', label: 'EX-01' }
];



export const notification = [

];

export const dataTypeConstant = [
    {
        id: 'Country', name: 'Country', api: 'country', coloumDuplicateCheck: true, duplicate: 'Country Name', fieldList: [
            { key: "Country Name", apiField: "name", required: true, limit: 40 },
            { key: "Long Name", apiField: "longName", trimLimit: 6 },
            { key: "Currency", apiField: "currency", relation: "name", required: true }
        ]
    },
    {
        id: 'State', name: 'State', api: 'state', coloumDuplicateCheck: true, duplicate: 'State Name', fieldList: [
            { key: "State Name", apiField: "name", required: true, limit: 40 },
            { key: "Short Name", apiField: "shortName", trimLimit: 6 },
            { key: "Country", apiField: "country", relation: "name", required: true }
        ]
    },
    {
        id: 'City', name: 'City', api: 'city', coloumDuplicateCheck: true, duplicate: 'City Name', fieldList: [
            { key: "City Name", apiField: "name", required: true, limit: 40 },
            { key: "State", apiField: "state", relation: "name", required: true },
            { key: "Country", apiField: "country", relation: "name", required: true }
        ]
    },
    {
        id: 'Pincode', name: 'Pincode', api: 'pincode', duplicate: 'Pincode', fieldList: [
            { key: "Pincode", apiField: "code", required: true, limit: 40 },
            { key: "City", apiField: "city", relation: "name", required: true },
            { key: "State", apiField: "state", relation: "name", required: true },
            { key: "Country", apiField: "country", relation: "name", required: true }
        ]
    },
    {
        id: 'Area', name: 'Area', api: 'area', duplicate: 'Area', fieldList: [
            { key: "Area", apiField: "name", required: true, limit: 40 },
            { key: "PinCode", apiField: "pincode", relation: "code", required: true },
            { key: "City", apiField: "city", relation: "name", required: true },
            { key: "State", apiField: "state", relation: "name", required: true },
            { key: "Country", apiField: "country", relation: "name", required: true }
        ]
    },
    {
        id: 'Location', name: 'Location', api: 'locations', duplicate: 'name', fieldList: [
            { key: "Name", apiField: "name", required: true, limit: 40 },
            { key: "Area", apiField: "area", relation: "name", required: true },
            { key: "PinCode", apiField: "pincode", relation: "code" },
            { key: "City", apiField: "city", relation: "name" },
            { key: "State", apiField: "state", relation: "name" },
            { key: "Country", apiField: "country", relation: "name" }
        ]
    },
    {
        id: 'Universal Product', api: 'universal-products', coloumDuplicateCheck: true, name: 'Universal Product', duplicate: 'Product Id', fieldList: [
            { key: "Product Id", apiField: "productId", required: true },
            { key: "Name", apiField: "productName", required: true },
            { key: "Description", apiField: "description" },
            { key: "Type", apiField: "type", required: true },
            { key: "Product Catalogue Code", apiField: "catalogue", relation: "cataloguePrefix" },
            { key: "Product Category Code", apiField: "category", relation: "categoryPrefix" },
            { key: "SKU Unit", apiField: "skuUnit", relation: "name", required: true },
            { key: "Sales Unit", apiField: "salesUnit", relation: "name", required: true },
            { key: "SKU Quantity", apiField: "skuQuantity", required: true },
            { key: "HSN Code", apiField: "hsn", relation: "hsnCode" },
            { key: "Product GST Code", apiField: "productGst", relation: "code" },
            { key: "Status", apiField: "status", required: true },
            { key: "Use MRP", apiField: "useMrp" },
            { key: "MRP", apiField: "mrp", type: "integer" },
            { key: "Price Includes Tax", apiField: "priceIncludesTax" },
            { key: "Bar Code", apiField: "barcode" },
            { key: "IAN Number", apiField: "ianNumber" }
        ]
    },
    {
        id: 'Unit Class', name: 'Unit Class', coloumDuplicateCheck: true, duplicate: 'Unit Class Name', fieldList: [
            { key: "Unit Class Name", apiField: "name", required: true }
        ]
    },
    {
        id: 'Unit of Measurement', name: 'Unit of Measurement', coloumDuplicateCheck: true, duplicate: 'Unit', fieldList: [
            { key: "Unit", apiField: "name", required: true },
            { key: "Description", apiField: "description" },
            { key: "Unit Class", apiField: "unitClass", required: true, relation: "name" },
            { key: "System of Units", apiField: "systemOfUnits" },
            { key: "Decimal Precision", apiField: "precision" }
        ]
    },
    {
        id: 'Adjust Stock Lines', name: 'Adjust Stock Lines', coloumDuplicateCheck: true, duplicate: 'Unit', fieldList: [
            { key: "Line Number", apiField: "lineNumber" },
            { key: "Product Name", apiField: "product", relation: "productName" },
            { key: "Product Description", apiField: "product", relation: "description" },
            { key: "Product ID", apiField: "product", relation: "productId", required: true },
            { key: "Unit", apiField: "unit", relation: "name" },
            { key: "Quantity", apiField: "quantity", required: true },
            { key: "Cost Price", apiField: "pricePerUnit" },
            { key: "Total Cost Price", apiField: "amount" },
            { key: "Location", apiField: "location", relation: "name" },
            { key: "MRP", apiField: "product", relation: "mrp" },
            { key: "Batch Applicable", apiField: "batchOverride" },
            { key: "Batch Number", apiField: "batchDetails", relation: "batchNumber", joinRelation: true },
            { key: "Party Name", apiField: "party", relation: "name" },
            { key: "Order ID", apiField: "orderDetails", relation: "serialNo" },
            { key: "Order Line Number", apiField: "orderLineDetails", relation: "lineNumber" },
            { key: "Order Line Description", apiField: "orderLineDetails", relation: "description" },
            { key: "Order Line Amount", apiField: "orderLineDetails", relation: "amount" }
        ]
    },
    {
        id: 'Stock Count Lines', name: 'Stock Count Lines', coloumDuplicateCheck: true, duplicate: 'Unit', fieldList: [
            { key: "Line Number", apiField: "lineNumber", required: true },
            { key: "Product Name", apiField: "product", relation: "productName" },
            { key: "Product ID", apiField: "product", relation: "productId" },
            { key: "Unit", apiField: "unit", relation: "name" },
            { key: "Current Stock", apiField: "currentStock" },
            { key: "Counted Quantity", apiField: "countedQuantity" },
            { key: "Quantity", apiField: "quantity" },
            { key: "Cost Price", apiField: "pricePerUnit" },
            { key: "Total Cost Price", apiField: "amount" },
            { key: "Location", apiField: "location", relation: "name" },
            { key: "MRP", apiField: "product", relation: "mrp" }
        ]
    }, {
        id: 'Stock Transfer Lines', name: 'Stock Transfer Lines', coloumDuplicateCheck: true, duplicate: 'Unit', fieldList: [
            { key: "Line Number", apiField: "lineNumber", required: true },
            { key: "Product Name", apiField: "product", relation: "productName" },
            { key: "Product ID", apiField: "product", relation: "productId" },
            { key: "Unit", apiField: "unit", relation: "name" },
            { key: "Quantity", apiField: "quantity" },
            { key: "To Quantity", apiField: "toQuantity" },
            { key: "Location", apiField: "location", relation: "name" },
            { key: "To Location", apiField: "toLocation", relation: "name" },
            { key: "Cost Price", apiField: "pricePerUnit" },
            { key: "Total Cost Price", apiField: "amount" }
        ]
    },
    {
        id: 'My Products', name: 'My Products', api: 'client-products', duplicate: 'Name', fieldList: [
            { key: "Name", apiField: "productName", required: true },
            { key: "Product ID", apiField: "productId" },
            { key: "Description", apiField: "description" },
            { key: "Type", apiField: "type", required: true },
            { key: "Product Group", apiField: "productGroup", relation: "name" },
            { key: "Product Catalogue Code", apiField: "catalogue", relation: "cataloguePrefix" },
            { key: "Product Category Code", apiField: "category", relation: "categoryPrefix" },
            { key: "SKU Unit", apiField: "skuUnit", relation: "name", required: true },
            { key: "SKU Quantity", apiField: "skuQuantity", required: true },
            { key: "HSN Code", apiField: "hsn", relation: "hsnCode" },
            { key: "Product GST", apiField: "productGst", relation: "code" },
            { key: "Status", apiField: "status", required: true },
            { key: "Prefered Supplier", apiField: "preferredSupplier", relation: "name" },
            { key: "Sell End Date", apiField: "sellEndDate" },
            { key: "Sales Unit", apiField: "salesUnit", relation: "name", required: true },
            { key: "Batch Activation", apiField: "batchActivation" },
            { key: "Use MRP", apiField: "useMrp" },
            { key: "MRP", apiField: "mrp", type: "integer" },
            { key: "Latest Purchase Price", apiField: "latestPurchasePrice", type: "integer" },
            { key: "Cost Price", apiField: "costPrice", type: "integer" },
            { key: "Price Includes Tax", apiField: "priceIncludesTax" },
            { key: "Product Code", apiField: "code" },
            { key: "Bar Code", apiField: "barcode" },
            { key: "IAN Number", apiField: "ianNumber" },
            { key: "Trans Type", apiField: "transType" },
            { key: "Universal Product", apiField: "universalProduct", relation: "productId", skip: true, importSkip: true },
            { key: "Excise Applicable", apiField: "exciseApplicable" },
            // { key: "Last Updated Date (MRP)", apiField: "mrpLastUpdatedDate" },
            // { key: "Latest Purchase Price Date", apiField: "latestPurchasePriceTs" },
            // { key: "Last Updated Date (Cost Price)", apiField: "costLastUpdatedDate" },
        ]
    },
    {
        id: 'Customers', name: 'Customers', api: "customerProfile", coloumDuplicateCheck: true, duplicate: 'Customer Name', fieldList: [
            { key: "Customer Name", apiField: "name", required: true },
            { key: "Customer ID", apiField: "serialNo" },
            { key: "Business Type", apiField: "type", required: true },
            { key: "Mobile", apiField: "mobile", required: true },
            { key: "Email Id", apiField: "email" },
            { key: "Classification", apiField: "classification" },
            { key: "Preferred Language", apiField: "language", required: true, relation: "name" },
            { key: "Group", apiField: "group", relation: "name" },
            { key: "GST Type", apiField: "taxType", required: true, relation: "taxCode" },
            { key: "Party GST Code", apiField: "partyGst", relation: "code", skip: true, importSkip: true },
            { key: "GST Number (GSTIN)", apiField: "gstin" },
            { key: "Address Line 1", apiField: "address1" },
            { key: "Area", apiField: "area", relation: "name" },
            { key: "Pincode", apiField: "pincode", relation: "code", required: true },
            { key: "Contact Name", apiField: "contactName" },
            { key: "Alternate Name", apiField: "tradingName" },
            { key: "Alternate Phone", apiField: "alternateMobile" },
            { key: "Price Includes Tax", apiField: "priceIncludesTax" },
            { key: "Method of Payment", apiField: "mop", relation: "method" },
            { key: "Cash Discount", apiField: "cashDiscount", relation: "code" },
            { key: "Tax Code", apiField: "taxCode", relation: "code" },
            { key: "TCS", apiField: "tcs", relation: "name" },
        ]
    },
    {
        id: 'Suppliers', name: 'Suppliers', api: "supplierProfile", coloumDuplicateCheck: true, duplicate: 'Supplier name', fieldList: [
            { key: "Supplier name", apiField: "name", required: true },
            { key: "Supplier ID", apiField: "serialNo" },
            { key: "Business Type", apiField: "type", required: true },
            { key: "Mobile", apiField: "mobile", required: true },
            { key: "Email Id", apiField: "email" },
            { key: "Classification", apiField: "classification" },
            { key: "Preferred Language", apiField: "language", required: true, relation: "name" },
            { key: "Group", apiField: "group", relation: "name" },
            { key: "GST Type", apiField: "taxType", required: true, relation: "taxCode" },
            { key: "Party GST Code", apiField: "partyGst", relation: "code", skip: true, importSkip: true },
            { key: "GST Number (GSTIN)", apiField: "gstin" },
            { key: "Address Line 1", apiField: "address1" },
            { key: "Area", apiField: "area", relation: "name" },
            { key: "Pincode", apiField: "pincode", relation: "code", required: true },
            { key: "Contact Name", apiField: "contactName" },
            { key: "Alternate Name", apiField: "tradingName" },
            { key: "Alternate Phone", apiField: "alternateMobile" },
            { key: "Price Includes Tax", apiField: "priceIncludesTax" },
            { key: "Method of Payment", apiField: "mop", relation: "method" },
            { key: "Cash Discount", apiField: "cashDiscount", relation: "code" },
            { key: "Tax Code", apiField: "taxCode", relation: "code" },
            { key: "TCS", apiField: "tcs", relation: "name" },
        ]
    },
    {
        id: 'Salesselfbill', name: 'Salesselfbill', duplicate: 'Sales self bill', fieldList: [
            { key: "Self Bill Number", apiField: "serialNo" },
            { key: "Customer Name", apiField: "name", required: true },
            { key: "Customer ID", apiField: "customer", relation: "serialNo" },
            { key: "Phone Number", apiField: "phone", required: true },
            { key: "Invoice Date", apiField: "invoiceDate" },
            { key: "Due Date", apiField: "dueDate" },
            { key: "Created Date", apiField: "createTs", type: "date" },
            { key: "Method of payment", apiField: "mop", relation: "method" },
            { key: "Currency ", apiField: "currency", relation: "name", required: true },
            { key: "Email", apiField: "email" },
            { key: "Party GST Code ", apiField: "partyGst", relation: "code" },
            { key: "Address Line 1", apiField: "address1" },
            { key: "Area", apiField: "area", relation: "name" },
            { key: "PinCode", apiField: "pincode", relation: "code", required: true },
            // { key: "City", apiField: "city", relation: "name" },
            // { key: "State", apiField: "state", relation: "name" },
            // { key: "Country", apiField: "country", relation: "name" },
            // { key: "Total Discount", apiField: "totalDiscount" },
            { key: "Net Amount", apiField: "netAmount" },
            { key: "GST Amount", apiField: "gstAmount" },
            { key: "Invoice Amount", apiField: "invoiceAmount" },
            { key: "Status", apiField: "billStatus" },
        ]
    },
    {
        id: 'Store Sales', name: 'Store Sales', duplicate: 'Cash Receipt Number', fieldList: [
            { key: "Cash Receipt Number", apiField: "cashReceiptNumber" },
            { key: "Name", apiField: "customerName", required: true },
            { key: "Phone Number", apiField: "customerMobile", required: true },
            { key: "Email", apiField: "customerEmail", required: true },
            // { key: "Transaction Date", apiField: "transactionDate" },
            { key: "Transaction Date", apiField: "transactionDate", type: "date" },
            { key: "Transaction Time", apiField: "transactionDate", type: "time" },
            { key: "Invoice Amount", apiField: "invoiceAmount" },
            { key: "User Name", apiField: "storeSalesUser", relation: "name" },
            { key: "Pos Number ", apiField: "posName", required: true },
            { key: "Status", apiField: "billStatus" },
        ]
    },
    {
        id: 'Purchaseselfbill', name: 'Purchaseselfbill', duplicate: 'Purchase self bill', fieldList: [
            { key: "Self Bill Number", apiField: "serialNo" },
            { key: "Customer Name", apiField: "name", required: true },
            { key: "Customer ID", apiField: "customer", relation: "serialNo" },
            { key: "Phone Number", apiField: "phone", required: true },
            { key: "Invoice Date", apiField: "invoiceDate" },
            { key: "Due Date", apiField: "dueDate", type: "date" },
            { key: "Created Date", apiField: "createTs", type: "date" },
            { key: "Method of payment", apiField: "mop", relation: "method" },
            { key: "Currency ", apiField: "currency", relation: "name", required: true },
            { key: "Email", apiField: "email" },
            { key: "Party GST Code ", apiField: "partyGst", relation: "code" },
            { key: "Address Line 1", apiField: "address1" },
            { key: "Area", apiField: "area", relation: "name" },
            { key: "PinCode", apiField: "pincode", relation: "code", required: true },
            // { key: "City", apiField: "city", relation: "name" },
            // { key: "State", apiField: "state", relation: "name" },
            // { key: "Country", apiField: "country", relation: "name" },
            // { key: "Total Discount", apiField: "totalDiscount" },
            { key: "Net Amount", apiField: "netAmount" },
            { key: "GST Amount", apiField: "gstAmount" },
            { key: "Invoice Amount", apiField: "invoiceAmount" },
            { key: "Status", apiField: "billStatus" },
        ]
    },
    {
        id: 'CustomerTransactions', name: 'CustomerTransactions', duplicate: 'Customer Transactions', fieldList: [
            { key: "Invoice Number", apiField: "salesInvoice", relation: "serialNo" },
            { key: "Payment ID", apiField: "customerPayment", relation: "serialNo" },
            { key: "Customer Name", apiField: "customer", relation: "name" },
            { key: "Customer ID", apiField: "customer", relation: "serialNo" },
            { key: "Date", apiField: "date" },
            { key: "Transcation Type", apiField: "type" },
            { key: "Document Date", apiField: "documentDate", type: "date" },
            { key: "Amount", apiField: "amount" },
            { key: "Balance", apiField: "balance" },
            { key: "Method Of Payment", apiField: "mop", relation: "method" },
            { key: "Sales Rep", apiField: "salesRep", relation: "name" }
        ]
    },
    {
        id: 'InvoiceHistory', name: 'InvoiceHistory', duplicate: 'Invoice History', fieldList: [
            { key: "Invoice Number", apiField: "serialNo" },
            { key: "Reference Number", apiField: "selfBill", relation: "serialNo" },
            { key: "Customer Name", apiField: "customerName" },
            { key: "Customer ID", apiField: "customer", relation: "serialNo" },
            { key: "Reference Source", apiField: "source" },
            { key: "Invoice Date", apiField: "invoiceDate", type: "date" },
            { key: "Due Date", apiField: "dueDate", type: "date" },
            { key: "Phone Number", apiField: "phone" },
            { key: "Method of payment", apiField: "mop", relation: "method" },
            { key: "Currency ", apiField: "currency", relation: "name", required: true },
            { key: "Email", apiField: "email" },
            { key: "Party GST Code ", apiField: "partyGst", relation: "code" },
            { key: "Address Line 1", apiField: "address1" },
            { key: "Area", apiField: "area", relation: "name" },
            { key: "PinCode", apiField: "pincode", relation: "code", required: true },
            { key: "City", apiField: "city", relation: "name" },
            { key: "State", apiField: "state", relation: "name" },
            { key: "Country", apiField: "country", relation: "name" },
            { key: "Invoice Amount", apiField: "invoiceAmount" },
            { key: "Balance amount", apiField: "balanceAmount" },
            { key: "Sales Rep", apiField: "salesRep", relation: "name" }
        ]
    },
    {
        id: 'DeliveryNoteHistory', name: 'DeliveryNoteHistory', duplicate: 'Invoice History', fieldList: [
            { key: "Delivery Note Number", apiField: "serialNo" },
            { key: "Customer Name", apiField: "customer_name" },
            { key: "Customer Phone", apiField: "customer_phone" },
            { key: "Customer Email", apiField: "customer_email" },
            { key: "Delivery Date", apiField: "deliveryDate", type: "date" },
            { key: "Delivery Status", apiField: "deliveryStatus" }
        ]
    },
    {
        id: 'CustomerPayment', name: 'CustomerPayment', duplicate: 'Customer Payment', fieldList: [
            { key: "Payment ID", apiField: "serialNo" },
            { key: "Customer Name", apiField: "customer", relation: "name" },
            { key: "Customer ID", apiField: "customer", relation: "serialNo" },
            { key: "Payment Date", apiField: "date" },
            { key: "Method Of Payment", apiField: "mop", relation: "method", required: true },
            { key: "Payment Amount", apiField: "paymentAmount", required: true },
            { key: "Currency ", apiField: "currency", relation: "name", required: true },
            { key: "Payment Reference", apiField: "reference" },
            { key: "Payment Status", apiField: "paymentStatus" },
        ]
    },
    {
        id: 'CustomerGroup', name: 'CustomerGroup', duplicate: 'Customer Group', fieldList: [
            { key: "Customer Group", apiField: "name", required: true },
            { key: "Description", apiField: "description" },
        ]
    },
    {
        id: 'RejectCodes', name: 'RejectCodes', coloumDuplicateCheck: true, duplicate: 'Codes', fieldList: [
            { key: "Codes", apiField: "rejectReasonCode", required: true },
            { key: "Description", apiField: "rejectReasonDesc" },
        ]
    },
    {
        id: 'Brands', name: 'Brands', api: 'brands', coloumDuplicateCheck: true, duplicate: 'Name', fieldList: [
            { key: "Name", apiField: "brandName", required: true },
            { key: "Brand ID", apiField: "brandId" },
            { key: "Short Name", apiField: "brandShortName" },
            { key: "Description", apiField: "description" },
        ]
    },
    {
        id: 'SupplierPayment', name: 'SupplierPayment', duplicate: 'Supplier Payment', fieldList: [
            { key: "Payment ID", apiField: "serialNo" },
            { key: "Supplier Name", apiField: "supplier", relation: "name" },
            { key: "Supplier ID", apiField: "supplier", relation: "serialNo" },
            { key: "Payment Date", apiField: "date" },
            { key: "Method Of Payment", apiField: "mop", relation: "method", required: true },
            { key: "Payment Amount", apiField: "paymentAmount", required: true },
            { key: "Currency ", apiField: "currency", relation: "name", required: true },
            { key: "Payment Reference", apiField: "reference" },
            { key: "Payment Status", apiField: "paymentStatus" },
        ]
    },
    {
        id: 'SupplierTransaction', name: 'SupplierTransaction', duplicate: 'Supplier Transaction', fieldList: [
            { key: "Invoice Number", apiField: "purchaseInvoice", relation: "serialNo" },
            { key: "Payment ID", apiField: "supplierPayment", relation: "serialNo" },
            { key: "Supplier Name", apiField: "supplier", relation: "name" },
            { key: "Supplier ID", apiField: "supplier", relation: "serialNo" },
            { key: "Date", apiField: "date" },
            { key: "Transcation Type", apiField: "type" },
            { key: "Document Date", apiField: "documentDate" },
            { key: "Amount", apiField: "amount" },
            { key: "Balance", apiField: "balance" },
            { key: "Method Of Payment", apiField: "mop", relation: "method" },
        ]
    },
    {
        id: 'PurchaseInvoice', name: 'PurchaseInvoice', duplicate: 'Purchase Invoice', fieldList: [
            { key: "Invoice Number", apiField: "serialNo" },
            { key: "Reference Number", apiField: "selfBill", relation: "serialNo" },
            { key: "Supplier Name", apiField: "supplierName" },
            { key: "Supplier ID", apiField: "supplier", relation: "serialNo" },
            { key: "Reference Source", apiField: "source" },
            { key: "Invoice Date", apiField: "invoiceDate" },
            { key: "Due Date", apiField: "dueDate" },
            { key: "Phone Number", apiField: "phone" },
            { key: "Method of payment", apiField: "mop", relation: "method" },
            { key: "Currency ", apiField: "currency", relation: "name", required: true },
            { key: "Email", apiField: "email" },
            { key: "Party GST Code ", apiField: "partyGst", relation: "code" },
            { key: "Address Line 1", apiField: "address1" },
            { key: "Area", apiField: "area", relation: "name" },
            { key: "PinCode", apiField: "pincode", relation: "code", required: true },
            { key: "Invoice Amount", apiField: "invoiceAmount" },
            { key: "Balance Amount", apiField: "balanceAmount" },
        ]
    },
    {
        id: 'SupplierGroup', name: 'SupplierGroup', duplicate: 'Supplier Group', fieldList: [
            { key: "Supplier Group", apiField: "name", required: true },
            { key: "Description", apiField: "description" },
        ]
    },
    {
        id: 'TeamUser', name: 'TeamUser', duplicate: 'Team User', fieldList: [
            { key: "Full Name", apiField: "name", required: true },
            { key: "Mobile", apiField: "mobile", required: true },
            { key: "Email", apiField: "email", required: true },
            { key: "Role", apiField: "role", relation: "name", required: true },
        ]
    },
    {
        id: 'GSTTransaction', name: 'GSTTransaction', duplicate: 'GST Transaction', fieldList: [
            { key: "Transaction Reference", apiField: "transactionReference" },
            { key: "Party Name", apiField: "partyName" },
            { key: "GSTIN number", apiField: "customer", secondField: 'supplier', relation: "gstin" },
            { key: "Place of supply", apiField: "salesInvoice", secondField: 'purchaseInvoice', relation: "state", extraRelation: "name" },
            { key: "Supplier Invoice Number", apiField: "supplierRefNum" },
            { key: "Invoice Number", apiField: "txnInvoiceNumber" },
            { key: "Transaction Date", apiField: "date" },
            { key: "Source", apiField: "type" },
            { key: "Party GST Code", apiField: "partyGst", relation: "code" },
            { key: "GST Direction", apiField: "direction" },
            { key: "Origin Amount", apiField: "originAmount" },
            { key: "Net GST Rate", apiField: "netTaxRate" },
            { key: "GST Amout", apiField: "calculatedValue" },
            { key: "SGST Amount", apiField: "sgst" },
            { key: "CGST Amount", apiField: "cgst" },
            { key: "IGST Amount", apiField: "igst" },
            { key: "Adjusted GST Value", apiField: "calculatedValue" },
            { key: "Invoice Amount", apiField: "invoiceAmount" }
        ]
    },
    {
        id: 'TAXTransaction', name: 'TAXTransaction', duplicate: 'Transaction Reference', fieldList: [
            { key: "Transaction Reference", apiField: "transactionReference" },
            { key: "Party Name", apiField: "partyName" },
            { key: "Pan", apiField: "customer", secondField: 'supplier', relation: "pan" },
            { key: "GSTIN number", apiField: "customer", secondField: 'supplier', relation: "gstin" },
            { key: "Place of supply", apiField: "salesInvoice", secondField: 'purchaseInvoice', relation: "state", extraRelation: "name" },
            { key: "Supplier Invoice Number", apiField: "supplierRefNum" },
            { key: "Invoice Number", apiField: "txnInvoiceNumber" },
            { key: "Transaction Date", apiField: "date" },
            { key: "Invoice Date", apiField: "invoiceDate" },
            { key: "Source", apiField: "type" },
            { key: "Party GST Code", apiField: "partyGst", relation: "code" },
            { key: "GST Direction", apiField: "direction" },
            { key: "Origin Amount", apiField: "originAmount" },
            { key: "Net GST Rate", apiField: "netTaxRate" },
            { key: "GST Amout", apiField: "calculatedValue" },
            { key: "SGST Amount", apiField: "sgst" },
            { key: "CGST Amount", apiField: "cgst" },
            { key: "IGST Amount", apiField: "igst" },
            { key: "Adjusted GST Value", apiField: "calculatedValue" },
            { key: "Invoice Amount", apiField: "invoiceAmount" },
            { key: "Cash Discount", apiField: "cashDiscount", relation: 'code' },
            { key: "Cash Discount Amount", apiField: "cashDiscountAmount" },
            { key: "Excise Amount", apiField: "excisesAmount" },
            { key: "Assessable Value", apiField: "assessableValue" },
            { key: "Tax Code", apiField: "taxCode", relation: "code" },
            { key: "Tax", apiField: "tax" },
            { key: "Tcs", apiField: "tcs" }
        ]
    },
    {
        id: 'GSTRHSNTransactions', name: 'GSTRHSNTransactions', duplicate: 'GSTRHSN Transaction', fieldList: [
            { key: "Transaction Reference", apiField: "transactionReference" },
            { key: "Supplier Invoice Number", apiField: "supplierRefNum" },
            { key: "Party Name", apiField: "partyName" },
            { key: "GSTIN number", apiField: "gstIn" },
            { key: "Place of supply", apiField: "placeOfSupply" },
            { key: "Invoice Number", apiField: "txnInvoiceNumber" },
            { key: "Transaction Date", apiField: "date" },
            { key: "Source", apiField: "type" },
            { key: "Origin Amount", apiField: "originAmount" },
            { key: "Invoice Amount", apiField: "invoiceAmount" },
            { key: "Product Name", apiField: "description" },
            { key: "Product ID", apiField: "product", relation: "productId" },
            { key: "Unit", apiField: "unit", relation: "name" },
            { key: "Quantity", apiField: "quantity" },
            { key: "Line Amout", apiField: "amount" },
            { key: "Discount", apiField: "discount" },
            { key: "Product GST Code", apiField: "productGst", relation: "code" },
            { key: "Gst Amount", apiField: "gstAmount" },
            { key: "HSN Code", apiField: "hsn", relation: "hsnCode" },
            { key: "SGST Amount", apiField: "sgst" },
            { key: "CGST Amount", apiField: "cgst" },
            { key: "IGST Amount", apiField: "igst" }
        ]
    },
    {
        id: 'GSTRSummaryTransactions', name: 'GSTRSummaryTransactions', duplicate: 'GSTRHSN Transaction', fieldList: [
            { key: "Invoice Number", apiField: "txnInvoiceNumber" },
            { key: "Invoice Date", apiField: "date" },
            { key: "Invoice Amount", apiField: "invoiceAmount" },
            { key: "Party Name", apiField: "partyName" },
            { key: "GSTIN number", apiField: "gstIn" },
            { key: "Place Of Supply", apiField: "placeOfSupply" },
            { key: "Source", apiField: "type" },
            { key: "Product GST Code", apiField: "productGstCode" },
            { key: "Taxable amount", apiField: "taxableAmount" },
            { key: "Quantity", apiField: "quantity" },
            { key: "SGST Percentage", apiField: "sgstPercentage" },
            { key: "Sum of SGST Amount", apiField: "sgst" },
            { key: "CGST Percentage", apiField: "cgstPercentage" },
            { key: "Sum of CGST Amount", apiField: "cgst" },
            { key: "IGST Percentage", apiField: "igstPercentage" },
            { key: "Sum of IGST Amount", apiField: "igst" },
            { key: "Sum of Line Amout", apiField: "amount" }
        ]
    },
    {
        id: 'GSTRHSNSummaryTransactions', name: 'GSTRHSNSummaryTransactions', duplicate: 'GSTRHSN Transaction', fieldList: [
            { key: "Invoice Number", apiField: "txnInvoiceNumber" },
            { key: "Invoice Date", apiField: "date" },
            { key: "Invoice Amount", apiField: "invoiceAmount" },
            { key: "Party Name", apiField: "partyName" },
            { key: "GSTIN number", apiField: "gstIn" },
            { key: "Place Of Supply", apiField: "placeOfSupply" },
            { key: "Source", apiField: "type" },
            { key: "Product GST Code", apiField: "productGstCode" },
            { key: "HSN Code", apiField: "hsn" },
            { key: "Taxable amount", apiField: "taxableAmount" },
            { key: "Quantity", apiField: "quantity" },
            { key: "SGST Percentage", apiField: "sgstPercentage" },
            { key: "Sum of SGST Amount", apiField: "sgst" },
            { key: "CGST Percentage", apiField: "cgstPercentage" },
            { key: "Sum of CGST Amount", apiField: "cgst" },
            { key: "IGST Percentage", apiField: "igstPercentage" },
            { key: "Sum of IGST Amount", apiField: "igst" },
            { key: "Sum of Line Amout", apiField: "amount" }
        ]
    },
    {
        id: 'Method of payment', name: 'Method of payment', duplicate: 'Method of payment', fieldList: [
            { key: "Method of payment", apiField: "method", required: true },
            { key: "Description", apiField: "description" },
        ]
    },
    {
        id: 'Wallet', name: 'Wallet', duplicate: 'Wallet', fieldList: [
            { key: "Digital Wallet", apiField: "name", required: true },
            { key: "Description", apiField: "description" },
            { key: "URL", apiField: "url", required: true },
        ]
    },
    {
        id: 'Product Group', name: 'Product Group', duplicate: 'Name', fieldList: [
            { key: "Name", apiField: "name", required: true },
            { key: "Description", apiField: "description" },
        ]
    },
    {
        id: 'Party Gst code', name: 'Party Gst code', duplicate: 'Party Gst code', fieldList: [
            { key: "Party GST Code", apiField: "code", required: true },
            { key: "Description", apiField: "description" },
        ]
    },
    {
        id: 'ProductGst', name: 'ProductGst', duplicate: 'Product Gst', fieldList: [
            { key: "Product GST Code", apiField: "code", required: true },
            { key: "Description", apiField: "description" },
            { key: "Product GST Code", apiField: "percentage", required: true },
        ]
    },
    {
        id: 'TaxCode', name: 'TaxCode', duplicate: 'Tax Code', fieldList: [
            { key: "Tax Code", apiField: "code", required: true },
            { key: "Description", apiField: "description" },
            { key: "Percentage", apiField: "percentage", required: true },
        ]
    },
    {
        id: 'OtherTaxes', name: 'OtherTaxes', duplicate: 'Type', fieldList: [
            { key: "Type", apiField: "taxType", required: true },
            { key: "Name", apiField: "name" },
            { key: "Percentage", apiField: "percentage", required: true },
            { key: "Threshold", apiField: "threshold", required: true },
        ]
    },
    {
        id: 'CashDiscount', name: 'CashDiscount', duplicate: 'Code', fieldList: [
            { key: "Code", apiField: "code", required: true },
            { key: "Description", apiField: "description" },
            { key: "Percentage", apiField: "percentage", required: true },
        ]
    },
    {
        id: 'HSNCode', name: 'HSNCode', api: 'hsns', duplicate: 'HSN Code', fieldList: [
            { key: "HSN Code", apiField: "hsnCode", required: true },
            { key: "Description", apiField: "description", required: true },
            { key: "Chapter", apiField: "chapter" },
            { key: "Product GST", apiField: "productGst" }
        ]
    },
    {
        id: 'Currency', name: 'Currency', duplicate: 'Currency', fieldList: [
            { key: "Currency", apiField: "name", required: true },
            { key: "Short Name", apiField: "shortName" },
            { key: "symbol", apiField: "symbol", required: true },
        ]
    },
    {
        id: 'Modules', name: 'Modules', duplicate: 'Modules', fieldList: [
            { key: "Module", apiField: "module", required: true },
            { key: "Description", apiField: "description" },
        ]
    },
    {
        id: 'Component Types', name: 'Component Types', duplicate: 'Component Types', fieldList: [
            { key: "Component Types", apiField: "componentType", required: true },
        ]
    },
    {
        id: 'Features', name: 'Features', duplicate: 'Features', fieldList: [
            { key: "Feature", apiField: "featureName", required: true },
            { key: "Description", apiField: "description" },
            { key: "Module", apiField: "module", relation: "module" },
        ]
    },
    {
        id: 'Role', name: 'Role', duplicate: 'Role', fieldList: [
            { key: "Role Name", apiField: "name", required: true },
        ]
    },
    {
        id: 'Address Book', name: 'Address Book', duplicate: 'Address Book', fieldList: [
            { key: "Name", apiField: "businessName", apiSecondField: "contactName" },
            { key: "GAB Id", apiField: "id" },
            { key: "Younote Id", apiField: "businessId" },
            { key: "Mobile Number", apiField: "mobile" },
            { key: "Email", apiField: "email" },
            { key: "Address Line 1", apiField: "address1", relation: "name" },
            { key: "Area", apiField: "area", relation: "name" },
            { key: "Pincode", apiField: "pincode", relation: "code" },
            { key: "City", apiField: "city", relation: "name" },
            { key: "State", apiField: "state", relation: "name" },
            { key: "Country", apiField: "country", relation: "name" },
        ]
    },
    {
        id: 'Address Book Lines', name: 'Address Book Lines', duplicate: 'Address Book Lines', fieldList: [
            { key: "GAB Id", apiField: "id" },
            { key: "Younote Id", apiField: "businessId" },
            { key: "Name/Business Name", apiField: "relGab", relation: "contactName" },
            { key: "User Type", apiField: "userType" }
        ]
    },
    {
        id: 'Maintain Price', name: 'Maintain Price', api: 'salesPriceAgreement', duplicate: 'Price ID', fieldList: [
            { key: "Price ID", apiField: "salesPriceId", required: true },
            { key: "Product ID", apiField: "product", relation: "productId", required: true },
            { key: "Product Name", apiField: "product", relation: "productName", skip: true, importSkip: true },
            { key: "Unit", apiField: "unit", relation: "name", required: true },
            { key: "Customer Specification", apiField: "customerSpec", required: true },
            { key: "Customer", apiField: "customer", relation: "serialNo" },
            { key: "Customer Name", apiField: "customer", relation: "name", skip: true, importSkip: true },
            { key: "Customer Group", apiField: "customerGroup", relation: "name" },
            { key: "Dynamic Price", apiField: "dynamicPrice", required: true },
            { key: "From Date", apiField: "fromDate", type: "integer", skip: true },
            { key: "To Date", apiField: "toDate", type: "integer", skip: true },
            { key: "Price", apiField: "price", type: "integer", required: true },
            { key: "Margin", apiField: "margin", type: "integer", },
            { key: "Purch Price Markup", apiField: "markup", type: "integer" },
            { key: "Cost Price", apiField: "cost", type: "integer" },
            { key: "Latest Purchase Price", type: "integer", apiField: "lastPurchasePrice" },
            { key: "Use MRP", apiField: "useMRP", type: "boolean" },
            { key: "MRP", apiField: "maxRetailPrice", type: "integer", },
            { key: "Status", apiField: "isActive", required: true },
            { key: "S.E.D- Special Excise Duty  (%)", apiField: "specialExcisesDutyPercentage" },
            { key: "S.E.D- Special Excise Duty", apiField: "specialExcisesDuty" },
        ]
    },
    {
        id: 'Customer Sales Price', name: 'Customer Sales Price', api: 'salesPriceAgreement', duplicate: 'Dynamic Price', fieldList: [
            { key: "Dynamic Price", apiField: "dynamicPrice", required: true, emptyCheck: true },
            { key: "Price ID", apiField: "salesPriceId", required: true },
            { key: "Product ID", apiField: "product", relation: "productId", required: true, emptyCheck: true },
            { key: "Product Name", apiField: "product", relation: "productName", skip: true, importSkip: true },
            { key: "Product Code", apiField: "product", relation: "code", skip: true, importSkip: true },
            { key: "Unit", apiField: "unit", relation: "name", required: true, emptyCheck: true },
            { key: "Customer Specification", apiField: "customerSpec", required: true, emptyCheck: true },
            { key: "Customer", apiField: "customer", relation: "serialNo" },
            { key: "Customer Name", apiField: "customer", relation: "name", skip: true, importSkip: true },
            { key: "Customer Group", apiField: "customerGroup", relation: "name" },
            { key: "From Date", apiField: "fromDate", type: "date" },
            { key: "To Date", apiField: "toDate", type: "date" },
            { key: "Price", apiField: "price", type: "integer", required: true, emptyCheck: true },
            { key: "Purch Price Markup", apiField: "markup", type: "integer" },
            { key: "Cost Price", apiField: "cost", type: "integer" },
            { key: "Latest Purchase Price", apiField: "lastPurchasePrice", type: "integer" },
            { key: "Use MRP", apiField: "useMRP", type: "boolean" },
            { key: "MRP", apiField: "maxRetailPrice", type: "integer" },
            { key: "Status", apiField: "isActive", required: true, emptyCheck: true },
            { key: "S.E.D- Special Excise Duty  (%)", apiField: "specialExcisesDutyPercentage" },
            { key: "S.E.D- Special Excise Duty", apiField: "specialExcisesDuty" },
        ]
    },
    {
        id: 'Product Unit Conversions', name: 'Product Unit Conversions', api: 'product-unit-conversion', duplicate: 'Conversion ID', fieldList: [
            { key: "Conversion ID", apiField: "id", required: true },
            { key: "Product ID", apiField: "product", relation: "productId", required: true, emptyCheck: true },
            { key: "Product Name", apiField: "product", relation: "productName", skip: true, importSkip: true },
            { key: "Product Code", apiField: "product", relation: "code", skip: true, importSkip: true },
            { key: "Unit", apiField: "unit", relation: "name", required: true, emptyCheck: true },
            { key: "To Unit", apiField: "toUnit", relation: "name", required: true, emptyCheck: true },
            { key: "Conversion Factor", apiField: "conversionFactor", required: true },
            { key: "Additional Factor", apiField: "additionalFactor" }
        ]
    },
    {
        id: 'Customer Sales Discount', name: 'Customer Sales Discount', api: 'sales-discounts', fieldList: [
            { key: "Price ID", apiField: "priceId", required: true },
            { key: "Product Specification", apiField: "productSpec", required: true },
            { key: "Product ID", apiField: "product", relation: "productId", required: true },
            { key: "Product Name", apiField: "product", relation: "productName", skip: true, importSkip: true },
            { key: "Product Code", apiField: "product", relation: "code", skip: true, importSkip: true },
            // { key: "Product Group Name", apiField: "productGroup", relation: "name" },
            { key: "Unit", apiField: "unit", relation: "name", required: true, emptyCheck: true },
            { key: "Customer Specification", apiField: "customerSpec", required: true, emptyCheck: true },
            { key: "Customer", apiField: "customer", relation: "serialNo" },
            { key: "Customer Name", apiField: "customer", relation: "name", skip: true, importSkip: true },
            { key: "Customer Group", apiField: "customerGroup", relation: "name" },
            { key: "From Date", apiField: "fromDate", type: "date" },
            { key: "To Date", apiField: "toDate", type: "date" },
            { key: "Discount Amount", apiField: "discountAmount", type: "integer" },
            { key: "Discount Percentage", apiField: "discountPercent", type: "integer" },
            { key: "Min Quantity", apiField: "minQty", type: "integer", required: true, },
            { key: "Status", apiField: "isActive", required: true, emptyCheck: true },
        ]
    },
    {
        id: 'Sales Quantity Discount', name: 'Sales Quantity Discount', api: 'sales-quantities', fieldList: [
            { key: "Price ID", apiField: "priceId", required: true },
            { key: "Quantity Specification", apiField: "quantitySpec", required: true },
            { key: "Product ID", apiField: "saleItem", relation: "productId", required: true },
            { key: "Product Name", apiField: "saleItem", relation: "productName", skip: true, importSkip: true },
            { key: "Product Code", apiField: "saleItem", relation: "code", skip: true, importSkip: true },
            { key: "Unit", apiField: "salesUnit", relation: "name", required: true, emptyCheck: true },
            { key: "Quantity", apiField: "salesQty", required: true, },
            { key: "Customer Specification", apiField: "customerSpec", required: true, emptyCheck: true },
            { key: "Customer", apiField: "customer", relation: "serialNo" },
            { key: "Customer Name", apiField: "customer", relation: "name", skip: true, importSkip: true },
            { key: "Customer Group", apiField: "customerGroup", relation: "name" },
            { key: "From Date", apiField: "fromDate", type: "date" },
            { key: "To Date", apiField: "toDate", type: "date" },
            { key: "Free Product ID", apiField: "freeItem", relation: "productId", required: true },
            { key: "Free Product Name", apiField: "freeItem", relation: "productName", skip: true, importSkip: true },
            { key: "Free Unit", apiField: "freeUnit", relation: "name", required: true, emptyCheck: true },
            { key: "Free Quantity", apiField: "freeQty", required: true, },
            { key: "Status", apiField: "isActive", required: true, emptyCheck: true },
        ]
    },
    {
        id: 'Customer Margin Price', name: 'Customer Margin Price', api: 'salesPriceAgreement', duplicate: 'Dynamic Price', fieldList: [
            { key: "Dynamic Price", apiField: "dynamicPrice", required: true, emptyCheck: true },
            { key: "Price ID", apiField: "salesPriceId", required: true },
            { key: "Product ID", apiField: "product", relation: "productId", required: true, skip: true, emptyCheck: true },
            { key: "Product Name", apiField: "product", relation: "productName", skip: true, importSkip: true },
            { key: "Product Code", apiField: "product", relation: "code", skip: true, importSkip: true },
            { key: "Unit", apiField: "unit", relation: "name", required: true, emptyCheck: true },
            { key: "Customer Specification", apiField: "customerSpec", required: true, emptyCheck: true },
            { key: "Customer", apiField: "customer", relation: "serialNo" },
            { key: "Customer Name", apiField: "customer", relation: "name", skip: true, importSkip: true },
            { key: "Customer Group", apiField: "customerGroup", relation: "name" },
            { key: "From Date", apiField: "fromDate", type: "date" },
            { key: "To Date", apiField: "toDate", type: "date" },
            { key: "Margin", apiField: "margin", type: "integer", required: true, emptyCheck: true },
            { key: "Cost Price", apiField: "cost", type: "integer" },
            { key: "Latest Purchase Price", apiField: "lastPurchasePrice", type: "integer" },
            { key: "Use MRP", apiField: "useMRP", type: "boolean" },
            { key: "MRP", apiField: "maxRetailPrice", type: "integer" },
            { key: "Status", apiField: "isActive", required: true, emptyCheck: true },
            { key: "S.E.D- Special Excise Duty  (%)", apiField: "specialExcisesDutyPercentage" },
            { key: "S.E.D- Special Excise Duty", apiField: "specialExcisesDuty" },
        ]
    },
    {
        id: 'Customer Purch Price Markup', name: 'Customer Purch Price Markup', api: 'salesPriceAgreement', duplicate: 'Dynamic Price', fieldList: [
            { key: "Dynamic Price", apiField: "dynamicPrice", required: true, emptyCheck: true },
            { key: "Price ID", apiField: "salesPriceId", required: true },
            { key: "Product ID", apiField: "product", relation: "productId", required: true, skip: true, emptyCheck: true },
            { key: "Product Name", apiField: "product", relation: "productName", skip: true, importSkip: true },
            { key: "Product Code", apiField: "product", relation: "code", skip: true, importSkip: true },
            { key: "Unit", apiField: "unit", relation: "name", required: true, emptyCheck: true },
            { key: "Customer Specification", apiField: "customerSpec", required: true, emptyCheck: true },
            { key: "Customer", apiField: "customer", relation: "serialNo" },
            { key: "Customer Name", apiField: "customer", relation: "name", skip: true, importSkip: true },
            { key: "Customer Group", apiField: "customerGroup", relation: "name" },
            { key: "From Date", apiField: "fromDate", type: "date" },
            { key: "To Date", apiField: "toDate", type: "date" },
            { key: "Purch Price Markup", apiField: "markup", type: "integer", required: true, emptyCheck: true },
            { key: "Cost Price", apiField: "cost", type: "integer" },
            { key: "Latest Purchase Price", apiField: "lastPurchasePrice", type: "integer" },
            { key: "Use MRP", apiField: "useMRP", type: "boolean" },
            { key: "MRP", apiField: "maxRetailPrice", type: "integer" },
            { key: "Status", apiField: "isActive", required: true, emptyCheck: true },
            { key: "S.E.D- Special Excise Duty  (%)", apiField: "specialExcisesDutyPercentage" },
            { key: "S.E.D- Special Excise Duty", apiField: "specialExcisesDuty" },
        ]
    },
    {
        id: 'Customer Discount Price', name: 'Customer Discount Price', api: 'salesPriceAgreement', duplicate: 'Dynamic Price', fieldList: [
            { key: "Dynamic Price", apiField: "dynamicPrice", required: true, emptyCheck: true },
            { key: "Price ID", apiField: "salesPriceId", required: true },
            { key: "Product ID", apiField: "product", relation: "productId", required: true, skip: true, emptyCheck: true },
            { key: "Product Name", apiField: "product", relation: "productName", skip: true, importSkip: true },
            { key: "Product Code", apiField: "product", relation: "code", skip: true, importSkip: true },
            { key: "Unit", apiField: "unit", relation: "name", required: true, emptyCheck: true },
            { key: "Customer Specification", apiField: "customerSpec", required: true, emptyCheck: true },
            { key: "Customer", apiField: "customer", relation: "serialNo" },
            { key: "Customer Name", apiField: "customer", relation: "name", skip: true, importSkip: true },
            { key: "Customer Group", apiField: "customerGroup", relation: "name" },
            { key: "From Date", apiField: "fromDate", type: "integer", skip: true },
            { key: "To Date", apiField: "toDate", type: "integer", skip: true },
            { key: "Discount Percentage", apiField: "discountPercentage", type: "integer", required: true, },
            { key: "Cost Price", apiField: "cost", type: "integer" },
            { key: "Latest Purchase Price", apiField: "lastPurchasePrice", type: "integer" },
            { key: "Use MRP", apiField: "useMRP", type: "boolean", required: true },
            { key: "MRP", apiField: "maxRetailPrice", type: "integer", required: true },
            { key: "Status", apiField: "isActive", required: true, emptyCheck: true },
        ]
    },
    {
        id: 'Supplier Purchase Price', name: 'Supplier Purchase Price', api: 'purchase-prices', duplicate: 'Product ID', fieldList: [
            { key: "Product ID", apiField: "product", relation: "productId", required: true },
            { key: "Price ID", apiField: "purchasePriceId", required: true },
            { key: "Product Name", apiField: "product", relation: "productName", skip: true, importSkip: true },
            { key: "Product Code", apiField: "product", relation: "code", skip: true, importSkip: true },
            { key: "Unit", apiField: "unit", relation: "name", required: true, emptyCheck: true },
            { key: "Price", apiField: "price", type: "integer" },
            { key: "Supplier", apiField: "supplier", relation: "serialNo", required: true },
            { key: "Supplier Name", apiField: "supplier", relation: "name", skip: true, importSkip: true },
            { key: "From Date", apiField: "fromDate", type: "integer", skip: true },
            { key: "To Date", apiField: "toDate", type: "integer", skip: true },
            { key: "Cost Price", apiField: "cost", type: "integer" },
            { key: "Latest Purchase Price", apiField: "lastPurchasePrice", type: "integer" },
            { key: "Use MRP", apiField: "useMrp", type: "boolean" },
            { key: "MRP", apiField: "maxRetailPrice", type: "integer" },
            { key: "Status", apiField: "isActive", required: true, emptyCheck: true },
            { key: "S.E.D- Special Excise Duty  (%)", apiField: "specialExcisesDutyPercentage" },
            { key: "S.E.D- Special Excise Duty", apiField: "specialExcisesDuty" },
        ]
    },
    {
        id: 'Outbound Batch Price List', name: 'Outbound Batch Price List', api: 'salesPriceAgreement', duplicate: 'Dynamic Price', fieldList: [
            { key: "Product Name", apiField: "product", relation: "productName" },
            { key: "Universal Product ID", apiField: "product", relation: "universalProduct", extraRelation: "productId" },
            { key: "Product ID", apiField: "product", relation: "productId" },
            { key: "From Date", apiField: "fromDate" },
            { key: "To Date", apiField: "toDate" },
            { key: "Unit", apiField: "unit", relation: "name" },
            { key: "Sales Price", apiField: "price" },
            { key: "MRP", apiField: "maxRetailPrice" },
        ]
    },
    {
        id: 'Inbound Batch Price List', name: 'Inbound Batch Price List', api: 'salesPriceAgreement', duplicate: 'Dynamic Price', fieldList: [
            { key: "Product Name", apiField: "product", relation: "productName" },
            { key: "Universal Product ID", apiField: "product", relation: "universalProduct", extraRelation: "productId" },
            { key: "Product ID", apiField: "inboundProductId" },
            { key: "Supplier Product ID", apiField: "product", relation: "productId" },
            { key: "From Date", apiField: "fromDate" },
            { key: "To Date", apiField: "toDate" },
            { key: "Unit", apiField: "unit", relation: "name" },
            { key: "Sales Price", apiField: "price" },
            { key: "MRP", apiField: "maxRetailPrice" }
        ]
    },
    {
        id: 'Price List', name: 'Price List', api: 'salesPriceAgreement', duplicate: '', fieldList: [
            { key: "Product Name", apiField: "product", relation: "productName" },
            { key: "Universal Product ID", apiField: "product", relation: "universalproduct", secondField: "productId", extraRelation: "productId" },
            { key: "Product ID", apiField: "product", relation: "productId" },
            { key: "From Date", apiField: "fromDate" },
            { key: "To Date", apiField: "toDate" },
            { key: "Unit", apiField: "unit", relation: "name" },
            { key: "Sales Price", apiField: "price" },
            { key: "MRP", apiField: "maxRetailPrice" },
            { key: "Update Date", apiField: "updateTs" }
        ]
    },
    {
        id: 'Batch Customers List', name: 'Batch Customers List', api: 'batch', duplicate: 'Customer Name', fieldList: [
            { key: "Customer Name", apiField: "name" },
            { key: "Customer ID", apiField: "serialNo" },
            { key: "Phone Number", apiField: "mobile" },
            { key: "Younote ID", apiField: "customerBusinessId" },
            { key: "In App Status", apiField: "inAppStatus" }
        ]
    },
    {
        id: 'ProductCategories', name: 'ProductCategories', duplicate: 'Product Categories', fieldList: [
            { key: "Catalogue Name", apiField: "catalogueName", required: true },
            { key: "Catalogue Prefix", apiField: "cataloguePrefix" },
        ]
    },
    {
        id: 'Delivery Details', name: 'Delivery Details', fieldList: [
            { key: "Customer Name", apiField: "customerName" },
            { key: "Customer ID", apiField: "customer", relation: "serialNo" },
            { key: "Invoice Number", apiField: "serialNo" },
            { key: "Invoice Date", apiField: "invoiceDate" },
            { key: "Reference", apiField: "selfBill", relation: "serialNo" },
            { key: "Total Del. Quantity", apiField: "salesInvoiceItems", calculation: "sum" },
            { key: "PIN Code", apiField: "pincode", relation: "code" },
            { key: "Place Of Supply", apiField: "state", relation: "name" }
        ]
    },
    {
        id: 'Stock Transaction', name: 'Stock Transaction', fieldList: [
            { key: "Product Name", apiField: "product" },
            { key: "Product ID", apiField: "productId" },
            { key: "Sold Unit", apiField: "soldUnit" },
            { key: "Sold Quantity", apiField: "soldQuantity" },
            { key: "Sold Amount", apiField: "soldAmount" },
            { key: "Purchase Unit", apiField: "purchaseUnit" },
            { key: "Purchase Quantity", apiField: "purchaseQuantity" },
            { key: "Purchase Amount", apiField: "purchaseAmount" },
            { key: "Average Price", apiField: "avgPrice" },
            { key: "Stock Value", apiField: "stockValue" }
        ]
    },
    {
        id: 'Inventory Transaction', name: 'Inventory Transaction', fieldList: [
            { key: "Lot ID", apiField: "inventory_lot" },
            { key: "Date", apiField: "transactionDate" },
            { key: "Product ID", apiField: "product", relation: "productId" },
            { key: "Product Name", apiField: "product", relation: "productName" },
            { key: "Product Code", apiField: "product", relation: "code" },
            { key: "Source", apiField: "reference_type" },
            { key: "Reference Transaction", apiField: "reference_transaction" },
            { key: "Stock Quantity", apiField: "quantity" },
            { key: "Stock Unit", apiField: "unit", relation: "name" },
            { key: "Bill Quantity", apiField: "billQuantity" },
            { key: "Bill Unit", apiField: "billUnit", relation: "name" },
            { key: "Location", apiField: "location", relation: "name" },
            { key: "Batch", apiField: "batch", relation: "batchNumber" },
            { key: "Status", apiField: "inventory_status" },
            { key: "Cost per unit", apiField: "cost_per_unit" },
            { key: "Price per unit", apiField: "price_per_unit" },
            { key: "Amount", apiField: "line_amount" },
            { key: "Party name", apiField: "party_name" },
            { key: "Financial reference", apiField: "financial_reference" },
            { key: "Party ID", apiField: "partyDetails", relation: "serialNo" },
            { key: "Party Name", apiField: "partyDetails", relation: "name" },
            { key: "Order ID", apiField: "orderDetails", relation: "serialNo" },
            { key: "Service Reference", apiField: "serviceReference" },
            { key: "Product Ref", apiField: "orderLineDetails", relation: "description" },
            { key: "Order Line Amount", apiField: "orderLineDetails", relation: "amount" }
        ]
    },
    {
        id: 'Batch Numbers', name: 'Batch Numbers', fieldList: [
            { key: "Batch Number", apiField: "batchNumber" },
            { key: "Product ID", apiField: "product", relation: "productId" },
            { key: "Product Name", apiField: "product", relation: "productName" },
            { key: "Product Code", apiField: "product", relation: "code" },
            { key: "Manufacturing Date", apiField: "manufacturingDate", type: "date" },
            { key: "Expiry Date", apiField: "expiryDate", type: "date" },
            { key: "Use By Date", apiField: "useByDate", type: "date" },
            { key: "Best Before Date", apiField: "bestBeforeDate", type: "date" },
            { key: "Purchase Quantity", apiField: "purchaseQuantity" },
            { key: "Purchase Price", apiField: "purchasePrice" },
            { key: "Per Unit Price", apiField: "perUnitPrice" },
            { key: "MRP", apiField: "mrp" },
            { key: "Sold Quantity", apiField: "soldQuantity" },
            { key: "Available Stock", apiField: "availableStock" },
            { key: "Reference Type", apiField: "reference_type" },
            { key: "Unit", apiField: "unit", relation: "name" },
            { key: "Location", apiField: "location", relation: "name" },
        ]
    },
    {
        id: 'Stock on Hand', name: 'Stock on Hand', fieldList: [
            { key: "Product ID", apiField: "serialNumber" },
            { key: "Product Name", apiField: "productName" },
            { key: "Product Code", apiField: "code" },
            { key: "Unit Quantity", apiField: "physicalQtyUnit" },
            { key: "Unit", apiField: "unit", relation: "name" },
            { key: "SKU Quantity", apiField: "physicalQtySkuUnit" },
            { key: "SKU Unit", apiField: "skuUnit", relation: "name" },
            { key: "Cost Amount", apiField: "costAmount" }
        ]
    },
    {
        id: 'Workflow', name: 'Workflow', fieldList: [
            { key: "Name", apiField: "name" },
            { key: "Description", apiField: "description" },
            { key: "Action", apiField: "action" },
            { key: "Action Status", apiField: "actionStatus" }
        ]
    },
    {
        id: 'Schedule Frequency', name: 'Schedule Frequency', fieldList: [
            { key: "Name", apiField: "name" },
            { key: "Description", apiField: "description" },
            { key: "Repeat Type", apiField: "repeatType" },
            { key: "Occurence Count", apiField: "occurenceCount" }
        ]
    },
    {
        id: 'Schedule Frequency', name: 'Schedule Frequency', fieldList: [
            { key: "Name", apiField: "name" },
            { key: "Description", apiField: "description" },
            { key: "Repeat Type", apiField: "repeatType" },
            { key: "Occurence Count", apiField: "occurenceCount" }
        ]
    },
    {
        id: 'Customer Products', name: 'Customer Products', fieldList: [
            { key: "Customer Name", apiField: "customer", relation: "name" },
            { key: "Customer ID", apiField: "customer", relation: "serialNo" },
            { key: "Product Name", apiField: "product", relation: "productName" },
            { key: "Product ID", apiField: "product", relation: "productId" },
            { key: "Status", apiField: "status" },
            { key: "Quantity", apiField: "quantity" },
            { key: "Unit", apiField: "unit", relation: "name" },
        ]
    },
    {
        id: 'CustomerProductsLines', name: 'CustomerProductsLines', fieldList: [
            { key: "Customer Name", apiField: "customer", relation: "name" },
            { key: "Customer ID", apiField: "customer", relation: "serialNo" },
            { key: "Product Name", apiField: "product", relation: "productName" },
            { key: "Product ID", apiField: "product", relation: "productId" },
            { key: "Quantity", apiField: "quantity" },
            { key: "Unit", apiField: "unit", relation: "name" },
            { key: "Status", apiField: "status" },
        ]
    },
    {
        id: 'CustomerScheduling', name: 'CustomerScheduling', fieldList: [
            { key: "Customer Name", apiField: "customer", relation: "name" },
            { key: "Customer ID", apiField: "customer", relation: "serialNo" },
            { key: "Email", apiField: "email" },
            { key: "Phone", apiField: "phone" },
            { key: "Bill Format", apiField: "billFormat" },
            { key: "Schedule Status", apiField: "scheduleStatus" },
            { key: "Send Notification", apiField: "sendNotification" }
        ]
    },
    {
        id: 'CustomerProductScheduling', name: 'CustomerProductScheduling', fieldList: [
            { key: "Product", apiField: "product", relation: "productName" },
            { key: "Product ID", apiField: "product", relation: "productId" },
            { key: "Status", apiField: "status" },
            { key: "Quantity", apiField: "quantity" },
            { key: "Unit", apiField: "unit", relation: "name" },
            { key: "Amount", apiField: "amount" },
            { key: "WorkFlow", apiField: "workflow", relation: "name" },
            { key: "Frequency", apiField: "scheduleFrequency", relation: "name" },
            { key: "Time", apiField: "schedule_time" },
            { key: "Status", apiField: "scheduleStatus" },
        ]
    },
    {
        id: 'Schedule Query-Result', name: 'Schedule Query-Result', fieldList: [
            { key: "Customer Name", apiField: "customer", relation: "name" },
            { key: "Product", apiField: "product", relation: "productName" },
            { key: "Product ID", apiField: "product", relation: "productId" },
            { key: "Work Flow", apiField: "workflow", relation: "name" },
            { key: "Status", apiField: "scheduleStatus" },
            { key: "Date of Schedule", apiField: "start_date" },
            { key: "Quantity", apiField: "quantity" },
            { key: "Unit", apiField: "unit", relation: "name" },
            { key: "Amount", apiField: "amount" },
            { key: "Frequency", apiField: "scheduleFrequency", relation: "name" }
        ]
    },
    {
        id: 'Schedule Lines', name: 'Schedule Lines', fieldList: [
            { key: "Product", apiField: "product", relation: "productName" },
            { key: "Product ID", apiField: "product", relation: "productId" },
            { key: "Date of Schedule", apiField: "date" },
            { key: "Quantity", apiField: "quantity" },
            { key: "Unit", apiField: "unit", relation: "name" },
            { key: "Amount", apiField: "amount" }
        ]
    },
];
